import Cookies from 'js-cookie';
import 'jquery-ui/ui/widgets/sortable.js';
import { loader } from "./_inc/loader";
import 'jquery-contextmenu';
import {replaceAll} from './utils';

import tinymce from 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/print';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/hr';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/pagebreak';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/visualchars';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/nonbreaking';
import 'tinymce/plugins/save';
import 'tinymce/plugins/table';
import 'tinymce/plugins/contextmenu';
import 'tinymce/plugins/directionality';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/template';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/textcolor';
import './editor/plugins/tags';
import './editor/plugins/preview-pdf';

const accounting = require('accounting-js');
require('jquery-ajax-native');
require('jquery-mask-plugin');
require('jquery.json-viewer/json-viewer/jquery.json-viewer.css');
require('jquery.json-viewer/json-viewer/jquery.json-viewer');
const formatxml = require('xml-formatter');
require('datatables.net');
require('datatables.net-dt/css/jquery.dataTables.min.css');
require('../sass/libraries/datatables.scss');
require('jquery-ui/ui/widgets/draggable');

/**
 * Variable de stockage des states de modals.
 * Permet de restaurer l'état d'une modale si le bouton 'annuler' est cliqué
*/
const modalsStates = {};

/**
 * Variable de stockage des selections des selects des modals.
 * Permet de restaurer les selections d'une modale si le bouton 'annuler' est cliqué
*/
const modalsSelectsStates = {};

/**
 * Enregistre l'état d'une modal ainsi que les selections actives. (select2)
 * @param {*} modal la modal a enregistrer
 */
const saveModalState = function(modal) {
    const modalId = $(modal).attr('id');
    const $modalContent = $('#' + modalId + " .modal-content").first();

    // Enregistrement du contenu
    modalsStates[modalId] = $modalContent.clone(true);

    // Récupèration et enregistrement des selections
    const selectsStates = [];
    $modalContent.find('select').each(function () {
        const id = $(this).attr('id');
        const name = $(this).attr('name');
        const selected = $(this).val();
        if (!selected) {
            return; // on stocke pas les selections vides
        }
        selectsStates.push({ id, name, selected });
    });
    modalsSelectsStates[modalId] = selectsStates;
};

/**
 * Restaure l'état d'une modale à son état précédent
 * @param {*} modal la modale a restaurer
 */
const restoreModalState = function (modal) {
    const $modal = $(modal);
    const modalId = $modal.attr('id');

    // contenu et selections de l'état précédent
    const modalContent = modalsStates[modalId];
    const modalSelectsStates = modalsSelectsStates[modalId];

    if (!modalContent) {
        return;
    }

    globalcourtage.resetSelect2($(modalContent));

    // retire le validator de la form si présent
    // sinon peut générer des problèmes de submit
    const $form = $modal.closest('form');
    let validator = null;
    if ($form) {
        validator = $form.data('validator');
        if (validator) {
            validator.destroy();
        }
    }

    // restaure le contenu sauvegardé
    $('#' + modalId +' .modal-content')
        .empty()
        .replaceWith(modalContent);

    // supprime les modales datepicker précedemment ajoutée
    $modal.find('.datepicker-container').remove();
    $modal.find('.datepicker').removeClass('hasDatePicker');

    // cas particulier popin banque dans page montage banque
    globalcourtage.initSelect2($modal);

    // restaure les selections de l'état précédent
    $modal.find('select').each(function () {
        const id = $(this).attr('id');
        const name = $(this).attr('name');
        for (const selectState of modalSelectsStates) {
            if (selectState.id === id && selectState.name === name) {
                $(this).val(selectState.selected).trigger('change.select2');
                break;
            }
        }
    });

    if (modalId == 'modal-banque') {
        globalcourtage.autocompleteSelect2FiltersBanques();
    }

    // Recrée les élément materialize
    globalcourtage.initDatePicker($modal);
    globalcourtage.autocompleteZipcodeCity($modal);
    $('.tooltipped', modal).tooltip();
    $('.tabs', modal).tabs();

    // restaure le validator si celui-ci était présent
    if ($form && validator) {
        $form.validate(validator.settings);
    }
};

/**
 * Réinitialise les select qui utilisent select2
 * @param {JQuery<HTMLElement>} element
 */
$.fn.globalcourtage.resetSelect2 = function(element = null) {
    if (element == null) {
        element = $('body');
    }

    element.find('select option[data-select2-id]').removeAttr('data-select2-id');

    element.find('select')
        .off('change.select2')
        .removeClass('select2-hidden-accessible')
        .removeAttr('data-live-search')
        .removeAttr('data-select2-id')
        .removeAttr('aria-hidden')
        .removeAttr('tabindex');

    element.find('.select2').remove();
};

/**
 * Uniformise la hauteur de toutes les cartes d'un conteneur comportant la classe '.cards-same-height'.
 */
$.fn.globalcourtage.ajusteHauteurCards = function()
{
    const $cardsWithSameHeight = $('.cards-same-height');
    $cardsWithSameHeight.each(function() {
        const $cardsContents = $cardsWithSameHeight.find('.card .card-content');
        let maxHeight = 0;
        $cardsContents.each(function() {
            if ($(this).height() > maxHeight) {
                maxHeight = $(this).height();
            }
        });
        $cardsContents.height(maxHeight);
    });
};

/**
 * format un élément d'un select2 selon les classes indiqués dans le select de base
 * @param {*} item
 * @returns
 */
const formatSelect2Item = function(item) {
    const element = $(item.element);
    if (element.hasClass('striked')) {
        return $('<span class="likeDisabledStyle">'+ item.text+'</span>');
    }
    return item.text;
};

/**
 * convertit la réponse d'un appel ajax à destination d'un select
 * en contenu du select
 * @param {*} response
 * @returns
 */
$.fn.globalcourtage.parseSelectAjaxResponse = function(response) {
    if (response == undefined) {
        return '';
    }

    let content = "";
    for(const item of response) {
        if (item.items != undefined) {
            // optgroup
            let optgroup = "<optgroup label=\"" + item.text + "\"";
            if (item.deleted != undefined && item.deleted == true) {
                optgroup += " class=\"striked\"";
            }
            optgroup += ">";

            content += optgroup;

            for(const subItem of item.items) {
                // option
                let option = "<option value=\"" + subItem.value + "\"";
                if (subItem.deleted != undefined && subItem.deleted == true) {
                    option += " class=\"striked\"";
                }
                option += ">" + subItem.text + "</option>";

                content += option;
            }

            content += '</optgroup>';
        } else {
            content += "<option value=\"" + item.value + "\">" + item.text + "</option>";
        }
    }

    return content;
};

/**
 * Initialise les select2
 * @param {JQuery<HTMLElement>} element indique l'élément à partir duquel l'initialisation est réalisée
 */
$.fn.globalcourtage.initSelect2 = function(element = null, data = null, selected = null, trig = false) {
    if (element == null) {
        element = $('body');
    }

    // si l'élément passé n'est pas un select, on recherche dedans les select
    if (!element.is('select')) {
        element = element.find('select');
    }

    element.each(function() {
        const $select = $(this);

        // ne touche pas aux select de la debugbar
        if ($select.hasClass('phpdebugbar-datasets-switcher')) {
            return;
        }

        // options communes
        const options = {
            language: "fr",
            width: "100%",
            dropdownAutoWidth : true,
            templateResult: formatSelect2Item,
            templateSelection: formatSelect2Item
        };

        // données passées manuellement
        if (data) {
            options.data = data;
        }

        // zone de recherche
        if (!$select.hasClass('selectSearch')) {
            options.minimumResultsForSearch = -1;
        }

        const placeholder = $select.data('placeholder') ?? '-- Sélectionnez --';

        // reinit selection
        if ($select.hasClass('allowClear')) {
            options.allowClear = true;
            options.placeholder = placeholder;
            options.language = {
                removeAllItems: function(){
                    return 'Vider la sélection';
                }
            };
        }

        // placeholder
        if ($select.hasClass('placeholded')) {
            options.placeholder = placeholder;
        }

        // matcher
        if ($select.hasClass('matcherSelect')) {
            options.matcher = function(params, data) {
                return modelMatcher(params, data);
            };
        }

        $select.select2(options);

        // gestion placeholder de l'input de recherche à l'ouverture d'un select search.
        $select.on('select2:open', () => {
            const $searchField = $('.select2-container--open .select2-search__field').last();
            if ($select.hasClass('search-placeholded')) {
                // on applique le placerholder renseigné dans les data.
                $searchField.prop('placeholder', $select.data('search-placeholder') ?? 'Rechercher');
            }

            // pour palier bug de jquery 3.6: Search not auto focusing in jQuery 3.6.0
            // https://github.com/select2/select2/issues/5993
            $searchField.get(0).focus();
        });

        // cas validation select2
        // permet de revalider un select dès que la selection est changée
        $select.on("change", function () {
            // vérifie si le select est présent dans un form avec validator
            const $selectForm = $select.closest('form');
            const selectValidator = $selectForm.data('validator');

            // s'il s'agit bien d'une form avec validation,
            // vérifie la validité du select
            if (selectValidator) {
                try {
                    $select.valid();
                } catch (err) {
                // TODO: a voir pourquoi certains selects génèrent une erreur de validator
                // alors que celui-ci est pourtant initialisé dans chaque page.
                // utilisation d'un try catch pour éviter de casser le reste du code
                    console.log('select2 valid error', err);
                }
            }
        });

        // selection
        if (selected) {
            $select.val(selected);
        }

        if (trig) {
            $select.trigger('change.select2');
        }
    });

    function modelMatcher (params, data) {
        data.parentText = data.parentText || "";

        // Always return the object if there is nothing to compare
        if ($.trim(params.term) === '') {
            return data;
        }

        // Do a recursive check for options with children
        if (data.children && data.children.length > 0) {
            // Clone the data object if there are children
            // This is required as we modify the object to remove any non-matches
            const match = $.extend(true, {}, data);

            // Check each child of the option
            for (let c = data.children.length - 1; c >= 0; c--) {
                const child = data.children[c];
                child.parentText += data.parentText + " " + data.text;

                const matches = modelMatcher(params, child);

                // If there wasn't a match, remove the object in the array
                if (matches == null) {
                    match.children.splice(c, 1);
                }
            }

            // If any children matched, return the new object
            if (match.children.length > 0) {
                return match;
            }

            // If there were no matching children, check just the plain object
            return modelMatcher(params, match);
        }

        // If the typed-in term matches the text of this term, or the text from any
        // parent term, then it's a match.
        const original = (data.parentText + ' ' + data.text).normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
        const term = params.term.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();

        // Check if the text contains the term
        if (original.indexOf(term) > -1) {
            return data;
        }

        // If it doesn't contain the term, don't return anything
        return null;
    }

};

/**
 * Effectue un reset de tous les composants select2 et les recrée
 * @param {*} element
 */
$.fn.globalcourtage.reinitSelect2 = function(element = null) {
    this.resetSelect2(element);
    this.initSelect2(element);
};

/* init toutes les functions de MaterializeCSS */
$.fn.globalcourtage.initMaterialize = function () {
    $('.sidenav').sidenav();
    $(".dropdown-trigger").each(function() {
        let closeOnClick = false;
        if ($(this).hasClass('dropdown-close-on-click')) {
            closeOnClick = true;
        }

        $(this).dropdown({
            alignment: 'right',
            constrainWidth: false,
            coverTrigger: false,
            closeOnClick: closeOnClick
        });
    });

    if($(window).width() > 640){
        $(".hover-dropdown").dropdown({
            alignment: 'left',
            constrainWidth: false,
            coverTrigger: false,
            hover: true
        });
    }else{
        $(".hover-dropdown").dropdown({
            alignment: 'left',
            constrainWidth: false,
            coverTrigger: false,
            hover: false,
        });
    }

    $('.collapsible').collapsible();

    // Modales
    globalcourtage.initModal();

    // Sécurité pour s'assurer qu'à chaque clic sur un modal-trigger, on ouvre bien la modale ciblée,
    // même si celle-ci n'a pas été initialisée pour une raison ou une autre.
    $('body').on('click', '.modal-trigger', function () {
        const modalId = $(this).attr('href');

        // si le href ne pointe pas vers un id de modal,
        // on passe. surement un traitement manuel.
        if (!modalId || !modalId.startsWith('#')) {
            return;
        }

        const $modal = $(modalId);

        // pas d'instance trouvée, on initialise à la volée avec ouverture.
        if ($modal && !M.Modal.getInstance($modal)) {
            globalcourtage.initModal($modal, true);
        }
    });

    // Fermeture d'une modale, rétabli les valeurs initiales
    $('body').on('click', '.modal-close:not(.close-previsu)', function() {
        restoreModalState($(this).closest('.modal'));
        // fermée automatiquement par framework materializecss
    });

    $('body').on('click', '.modal-save', function() {
        M.Modal.getInstance($(this).closest('.modal')).close();
    });

    globalcourtage.initSelect2();

    $('.auto-width').parent('.select-wrapper').addClass('auto-width');
    $('.auto-width.white').parent('.select-wrapper').addClass('auto-width white');

    // augmente la zone de resulats du select2 (filtres dossiers)
    var $bigSelects = $('.bigdrop-select');
    if ($bigSelects.length > 0) {
        $bigSelects.select2().data('select2').$results.addClass('bigdrop');
    }

    $('.multiple-select-dropdown input').addClass('filled-in');

    $('.tooltipped').tooltip({
        inDuration: 0,
        outDuration: 0,
        enterDelay: 0,
        exitDelay: 0,
        transitionMovement: 0
    });

    $('.toastTrigger').trigger('click');

    // gestion fermeture toasts
    $('.toast-close').on("click", function () {
        const $toast = $(this).parent();
        const toastInstance = M.Toast.getInstance($toast);
        toastInstance.dismiss();
    });


    if($('.opener-floating-menu').length > 0){
        $('.opener-floating-menu').click(function(){
            $(this).closest('.toolbar-actions-btn').find('ul').toggleClass('hide');
        });
    }

};

/**
 * Initialise toutes les modales dans le contexte indiqué.
 * @param {*} context le contexte surlequel initialiser les modales
 * @param {bool} open ouverture ou non de la modal après l'init
 */
$.fn.globalcourtage.initModal = function (context = null, open = false) {
    if (context == null) {
        context = 'body';
    }
    const $context = $(context);

    // soit le contexte est déjà une modale, sinon on cherche les modales dedans
    let $modals = $context;
    if (!$context.hasClass('modal')) {
        $modals = $context.find('.modal')
    }

    $modals.each(function () {
        const $modal = $(this);

        // gère les modals qui ne peuvent pas être fermées avec clic à côté
        const dismissible = !$modal.hasClass('non-dismissible-modal');

        $modal.modal({
            dismissible: dismissible,
            onOpenEnd: function () {
                globalcourtage.modalDraggable(this);
                // globalcourtage.reinitSelect2($(this));
                $('.multiple-select-dropdown input').addClass('filled-in');
                $('.modal').removeAttr('tabindex');
                saveModalState(this);
                $('.tabs').tabs();
            }
        });

        // ouverture à l'init
        if (open) {
            M.Modal.getInstance($modal).open();
        }
    });
};

/* déplie / replie le menu principal */
$.fn.globalcourtage.toggleMainNavigation = function() {
    if($(window).width() > 993) {
        $('.sidenav').addClass('smallnav');

        $('.sidenav-close').on('click', function () {
            $('.sidenav').toggleClass('smallnav');
            $('#app').toggleClass('fullwidth');
            $('#app').removeClass('opened-right');
            $('.sidecontent-unfloating').removeClass('open');
            $('.unfloating-button-container').removeClass('open');

            if($('.sidenav').hasClass('smallnav')){
                $('.sidenav-close i').text('menu');
                $('.sidenav li').removeClass('active');
                $('.submenu-body').slideUp();

                $('.sidenav .tooltipped').tooltip({
                    inDuration: 0,
                    outDuration: 0,
                    enterDelay: 0,
                    exitDelay: 0,
                    transitionMovement: 0
                });
            }else{
                $('.sidenav .tooltipped').tooltip('destroy');

                $('.sidenav-close i').text('menu_open');
            }

            $('.sidenav.smallnav .collapsible-header').click(function() {
                $('.sidenav').removeClass('smallnav');
                $('#app').removeClass('fullwidth opened-right');
                $('.sidecontent-unfloating').removeClass('open');
                $('.unfloating-button-container').removeClass('open');
            });
        });
    }else{
        $('.sidenav').removeClass('smallnav');
    }

    $('.sidenav.smallnav .collapsible-header').click(function() {
        $('.sidenav').removeClass('smallnav');
        $('#app').removeClass('fullwidth opened-right');
        $('.sidecontent-unfloating').removeClass('open');
        $('.unfloating-button-container').removeClass('open');
    });

    $('.submenu-header').click(function() {
        // on affiche le menu large
        if($('.sidenav').hasClass('smallnav')){
            $('.sidenav').removeClass('smallnav');
            $('#app').removeClass('fullwidth opened-right');
            $('.unfloating-button-container').removeClass('open');
            $('.sidenav-close i').text('menu_open');

            $('.sidenav .tooltipped').tooltip('destroy');
        }

        if($(this).next('.submenu-body').is(':visible')){
            $(this).parent().removeClass('active');
            $(this).next('.submenu-body').slideUp();
        }else{
            $(this).parent().addClass('active');
            $(this).next('.submenu-body').slideDown();
        }
    });
};

$.fn.globalcourtage.resetDatePicker = function(element = null) {
    if (element == null) {
        element = $('body');
    }

    element.find('.datepicker-container').remove();
    element.find('.datepicker').removeClass('hasDatePicker');
};

/* gère le datepicker */
$.fn.globalcourtage.initDatePicker = function(element = null) {
    if (element == null) {
        element = $('body');
    }

    // init les masks sur les inputs de date
    $('.mask_date', element).each(function(){
        $(this).mask("00/00/0000", {
            placeholder: "__/__/____",
            clearIfNotMatch: true}
        );
    });

    $('.datepicker', element).not('.hasDatePicker').datepicker({
        format: 'dd/mm/yyyy',
        autoClose: true,
        yearRange: 100,
        showClearBtn: true,
        firstDay: 1,
        onOpen: function() {
            let splitDate;
            if($(this.el).siblings('.mask_date').length > 0){
                splitDate = $(this.el).siblings('.mask_date').val().split("/");
            }else{
                splitDate = $(this.el).val().split("/");
            }

            if (splitDate.length === 3) {
                var newDate = new Date(parseInt(splitDate[2]), (parseInt(splitDate[1]) - 1), parseInt(splitDate[0]));
                var instance = M.Datepicker.getInstance(this.el);
                instance.setDate(newDate);
                $(this.el).siblings('.mask_date').val(splitDate[0] + '/' + splitDate[1] + '/' + splitDate[2]);
            }
        },
        onSelect: function(){
            if($('.range-date-first').length > 0){
                $(".range-date-first").focus();
            }
        },
        onClose: function() {
            let splitDate;
            splitDate = jQuery(this.el).val().split("/");

            if (splitDate.length === 3) {
                var newDate = new Date(parseInt(splitDate[2]), (parseInt(splitDate[1]) - 1), parseInt(splitDate[0]));
                var instance = M.Datepicker.getInstance(this.el);
                instance.setDate(newDate);
                $(this.el).siblings('.mask_date').val(splitDate[0] + '/' + splitDate[1] + '/' + splitDate[2]).trigger('change');
            }

            // // calcul écart mois entre deux dates si besoin
            // $(".range-date-first, .range-date-second").blur();
        },
        i18n: {
            labelMonthSelect: 'Selectionner le mois',
            labelYearSelect: 'Selectionner une année',
            months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
            monthsShort: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
            weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
            weekdaysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
            weekdaysAbbrev: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
            today: 'Aujourd\'hui',
            clear: 'Réinitialiser',
            cancel: 'Annuler',
        },
        // container: permet de ressortir la modale de selection du container par défaut (ex. une div),
        // ce qui évite que la fenêtre de selection soit écrasée
        container: 'body'
    })
    .addClass('hasDatePicker');

    $('.datepicker-clear').click(function() {
        $(this).closest('.datepicker-wrapper').find('input').val(null);
    });
};

/**
 * Reinitialise un datepicker.
 * @param {*} context le contexte sur lequel l'initialisation doit se lancer.
 */
$.fn.globalcourtage.reinitDatePicker = function(context = null)
{
    this.resetDatePicker(context);
    this.initDatePicker(context);
};


/* gère le comportement des filtres */
$.fn.globalcourtage.handleFilters = function() {
    $('.options_filtre').val(null);

    let filtresBanqueChoisiAppended = false;

    if($('.banque-choisie-wrapper').length > 0){
        filtresBanqueChoisiAppended = true;
    }

    $('.options_filtre').on('select2:select', function() {
        let inputToAppend;
        let multiple = '';
        const optionSelected = $('option:selected', this);
        const typeField = optionSelected.data('type');
        const specField = optionSelected.data('spec');
        const infoField = optionSelected.data('info');
        const valeursField = optionSelected.data('valeurs');
        const impactField = optionSelected.data('impact');
        const optgroupAideSaisie = globalcourtage.getAideSaisieOptgroup();
        const includeDelete = optionSelected.data('inc_delete');

        switch (typeField) {
            case 'checkbox':
                inputToAppend =
                    `<div class="input-field filtre-half wrapper-form-input"> \
                        <label class="form-check-label" for="${optionSelected.val()}"> \
                            <input data-type="${typeField}"  data-filtre="${optionSelected.val()}" class="form-check-input input-filter filled-in" type="checkbox" id="${optionSelected.val()}" value="1" checked="checked"> \
                            <span>${optionSelected.text()}</span> \
                        </label> \
                        <a href="javascript:void(0)" class="delete-btn-filtre btn small grey white-text"> \
                            <i class="material-icons">close</i> \
                        </a> \
                    </div>`;
                break;
            case 'text':
                inputToAppend =
                    `<div class="input-field filtre-half wrapper-form-input"> \
                        <input
                            data-type="${typeField}"
                            data-filtre="${optionSelected.val()}"
                            class="input-with-checkbox input-filter"
                            type="text"
                            name="filtre-${optionSelected.val()}"
                            id="filtre-${optionSelected.val()}"> \
                        <label class="form-check-label" for="filtre-${optionSelected.val()}">${optionSelected.text()}</label> \
                        <a href="javascript:void(0)" class="delete-btn-filtre btn small grey white-text"> \
                            <i class="material-icons">close</i> \
                        </a> \
                    </div>`;
                break;
            case 'date':
                inputToAppend =
                    `<div class="filtre-half filtre-date wrapper-form-input"> \
                        <select class="classicSearch search-date-filter" id="comparaisonDate-${optionSelected.val()}" data-filtre="${optionSelected.val()}"> \
                            <option value='sup'>>=</option> \
                            <option value='between'>entre</option> \
                            <option value='inf'><=</option> \
                            <optgroup label="Aide à la saisie"> \
                            ${optgroupAideSaisie} \
                            </optgroup>
                        </select> \
                        <label class="form-check-label" for="${optionSelected.val()}">${optionSelected.text()}</label> \
                        <div class="input-field input-with-date"> \
                            <div class="datepicker-wrapper"> \
                                <a href="javascript:void(0)" class="datepicker datepicker-icon"> \
                                    <i class="material-icons">event</i> \
                                </a> \
                                <input id="filtre-${optionSelected.val()}" data-type="${typeField}" data-filtre="${optionSelected.val()}" class="mask_date input-with-checkbox input-filter" type="text"> \
                            </div> \
                            <div class="datepicker-wrapper"> \
                                <a href="javascript:void(0)" class="datepicker datepicker-icon"> \
                                    <i class="material-icons">event</i> \
                                </a> \
                                <input id="filtre2-${optionSelected.val()}" data-type="${typeField}" data-filtre="${optionSelected.val()}" class="mask_date input-with-checkbox" type="text"> \
                            </div> \
                        </div> \
                        <a href="javascript:void(0)" class="delete-btn-filtre btn small grey white-text"> \
                            <i class="material-icons">close</i> \
                        </a> \
                    </div>`;
                break;
            case 'numeric':
                inputToAppend =
                    `<div class="filtre-half filtre-date wrapper-form-input"> \
                        <select class="classicSearch search-date-filter" id="comparaisonDate-${optionSelected.val()}" data-filtre="${optionSelected.val()}"> \
                            <option value='equal'>=</option> \
                            <option value='sup'>>=</option> \
                            <option value='between'>entre</option> \
                            <option value='inf'><=</option> \
                        </select> \
                        <label class="form-check-label" for="${optionSelected.val()}">${optionSelected.text()}</label> \
                        <div class="input-field input-with-date numbers-wrapper"> \
                            <input id="filtre-${optionSelected.val()}" data-type="${typeField}" data-filtre="${optionSelected.val()}" class=" input-with-checkbox input-filter" type="number"> \
                            <input id="filtre2-${optionSelected.val()}" data-type="${typeField}" data-filtre="${optionSelected.val()}" class=" input-with-checkbox" type="number"> \
                        </div> \
                        <a href="javascript:void(0)" class="delete-btn-filtre btn small grey white-text"> \
                            <i class="material-icons">close</i> \
                        </a> \
                    </div>`;
                break;
            case 'select':
                if( specField === 'multiple') {
                    multiple = 'multiple="multiple"';
                }

                // on ajoute la partie impact seulement si nécessaire
                let impact = '';

                if(impactField !== undefined && impactField.length > 0){
                    impact = 'data-impact="' + impactField + '"';
                }

                inputToAppend =
                    `<div class="input-field filtre-half wrapper-form-input"> \
                        <select data-valeurs="${valeursField}" ${impact} data-type="${typeField}" data-filtre="${optionSelected.val()}" class="selectSearch input-filter allowClear select-${optionSelected.val()} autocomplete-select2-${optionSelected.val()}" ${multiple}>`;

                if( specField != 'multiple') {
                    inputToAppend += `<option value=""></option>`;
                }
                    for (const valeur in valeursField) {
                        if (typeof valeursField[valeur] == 'object') {
                            // liste avec groupes
                            inputToAppend += `<optgroup label="${valeursField[valeur]['label']}">`;
                            for (const list_valeur in valeursField[valeur]['list']) {
                                inputToAppend += `<option value="${list_valeur}">${valeursField[valeur]['list'][list_valeur]}</option>`;
                            }
                            inputToAppend += `</optgroup>`;
                        } else {
                            // liste simple
                            inputToAppend += `<option value="${valeur}">${valeursField[valeur]}</option>`;
                        }
                    }

                inputToAppend +=
                    `</select> \
                         <label class="form-check-label" for="${optionSelected.val()}">${optionSelected.text()}</label>`;

                if(includeDelete){
                    inputToAppend += `<label class="sorti-checkbox"> \
                        <input value="1" type="checkbox" data-filtre="inc_delete_${optionSelected.val()}" class="filled-in input-filter" name="inc_delete_${optionSelected.val()}" /> \
                        <span class="tooltipped" data-tooltip="Cochez pour afficher les sortis"></span> \
                    </label>`;
                }

                if(infoField !== undefined && infoField){
                    inputToAppend += '<i class="material-icons tooltipped" data-tooltip="'+infoField+'">info</i>';
                }

                inputToAppend += `<a href="javascript:void(0)" class="delete-btn-filtre btn small grey white-text"> \
                            <i class="material-icons">close</i> \
                        </a> \
                    </div>`;

                // cas de la cac banque choisie - visible uniquement sur listing dossiers client
                const filtresBanques = ['banque', 'banque_agence', 'banque_interlocuteurs', 'famille_banque', 'ss_famille_banque'];
                let classBanques;

                if(filtresBanques.includes(optionSelected.val())){
                    classBanques = 'filtre-type-banque-wrapper';
                }

                if(filtresBanques.includes(optionSelected.val()) && !filtresBanqueChoisiAppended && window.location.href.includes('dossiers-client')){
                    inputToAppend +=
                        `<div class="input-field filtre-half wrapper-form-input banque-choisie-wrapper"> \
                            <label class="form-check-label" for="banque_choisie"> \
                                <input data-type="checkbox"  data-filtre="banque_choisie" class="form-check-input input-filter filled-in" type="checkbox" id="banque_choisie" value="1" checked="checked"> \
                                <span>Uniquement banque choisie ?</span> \
                            </label> \
                            <a href="javascript:void(0)" class="delete-btn-filtre btn small grey white-text"> \
                                <i class="material-icons">close</i> \
                            </a> \
                        </div>`;

                    filtresBanqueChoisiAppended = true;
                }

                break;
            case 'decimal':
                inputToAppend =
                    `<div class="input-field filtre-half flex wrapper-form-input"> \
                        <select style="width:10%" id="comparaisonValue-${optionSelected.val()}"> \
                            <option value='sup'>></option> \
                            <option value='inf'><</option> \
                        </select> \
                        <input id="filtre-${optionSelected.val()}" data-type="${typeField}" data-filtre="${optionSelected.val()}" class="mask-decimal input-with-checkbox input-filter" type="text"> \
                        <label class="form-check-label" for="${optionSelected.val()}">${optionSelected.text()}</label> \
                        <a href="javascript:void(0)" class="delete-btn-filtre btn small grey white-text"> \
                            <i class="material-icons">close</i> \
                        </a> \
                    </div>`;
                break;
        }

        optionSelected.prop('disabled', true);
        const filtreAppend = $('.filtres-select').append(inputToAppend);

        $('.tooltipped').tooltip();

        // on relance le select2 sur le dernier select ajouté si un select a été ajouté
        if(typeField == 'select'){
            globalcourtage.initSelect2(filtreAppend);
            globalcourtage.autocompleteSelect2Filters();
            globalcourtage.autocompleteSelect2FiltersBanques();
            globalcourtage.autocompleteSelect2Commerciaux();
        }

        if(typeField == 'date' || typeField == 'numeric'){
            globalcourtage.initSelect2($('.filtres-options-append').find('.search-date-filter').parent());
        }

        // on active le datepicker
        globalcourtage.initDatePicker();

        // on active les labels des inputs text
        $('.input-field input[type="text"]').siblings('label').addClass('active');

        // replace le select de filtres sur la valeur vide 'Ajouter un filtre'
        $('.options_filtre').val(null).trigger('change.select2');
    })
    // cas particulier du résultat déjà selected dans le select
    .on('select2:opening', function(event){
        // $('select.selectSearch').val(null);
    });

    $('.filtres-select-actifs .chip').each(function() {
        const filtre = $(this).data('filtre');
        $('.options_filtre option[value="'+filtre+'"]').prop('disabled', true);
    });

    $('.filtres .btn.blue').click(function(e) {
        const urlFiltre = globalcourtage.genereFiltersUrl();
        $(this).attr('href', urlFiltre);
    });

    // cas suppression d'un filtre
    $('body').delegate('.delete-btn-filtre', 'click', function() {
        const inputField = $(this).closest('.wrapper-form-input');
        const elementSelected = inputField.find('input, select').data('filtre');
        $('.option-'+elementSelected).prop('disabled', false);
        $('.options_filtre').val(null).trigger('change');

        // cas des selects avec impacts - on reset les selects à la suppression
        const selectImpact = inputField.find('.selectSearch:not(.options_filtre)');
        if(selectImpact.length > 0){
            selectImpact.val(null).trigger('change');
            handleImpacts(selectImpact);
        }
        inputField.remove();

        // cas suppression de tous les filtres banque, on enlève le filtre banque choisie
        if($('.filtre-type-banque-wrapper').length == 0){
            $('.banque-choisie-wrapper').remove();
            filtresBanqueChoisiAppended = false;
        }
    });

    /* on actualise l'aide à la saisie */
    $('.aide-saisie-optgroup').html(globalcourtage.getAideSaisieOptgroup());
    // cas checkbox pour afficher les sortis dans le select à côté
    $('body').delegate('.sorti-checkbox input', 'click', function(){
        const filtre = $(this).data('filtre');
        if($(this).is(':checked')){
            $(this).closest('.wrapper-form-input').find('.select2-selection__rendered').trigger('click');
            const select2Cible = $(this).closest('.wrapper-form-input').find('.select2-selection').attr('aria-owns');
            const lis = $('#'+select2Cible).find('li[data-select2-id*="deleted"]');
            lis.addClass('visible');
            $('#select2-filtre-'+filtre+'-results').trigger('change');
        }
    });

    $('body').delegate('.wrapper-form-input .select2-selection__rendered', 'click', function() {
        const select2Container = $(this).closest('.select2-container');
        const visibleCheckbox = select2Container.siblings('.sorti-checkbox').find('input');
        const filtre = visibleCheckbox.data('filtre');

        if(visibleCheckbox.is(':checked')){
            const select2Cible = $(this).closest('.wrapper-form-input').find('.select2-selection').attr('aria-owns');
            const lis = $('#'+select2Cible).find('li[data-select2-id*="deleted"]');
            lis.addClass('visible');
            $('#select2-filtre-'+filtre+'-results').trigger('change');
        }
    });

    /*
        cas aide à la saisie, 7 derniers jours et 30 derniers jours : on utilise 2 champs inputs pour pré-remplir un between de dates (7 jours ou 30 jours d'amplitude)
     */

    // cas filtre date between, deux inputs au lieu d'un
    $('body').delegate('.search-date-filter', 'change', function() {
        const inputsField = $(this).parent().find('.input-field');
        inputsField.find('input').val(null);

        if($(this).val() == 'between'){
            inputsField.addClass('between');

            // cas aide
            const dateDebut = $(this).find(':selected').data('debut');
            const dateFin = $(this).find(':selected').data('fin');

            if(dateDebut !== undefined && dateFin !== undefined){
                inputsField.find('.datepicker-wrapper:nth-child(1) input').val(dateDebut);
                inputsField.find('.datepicker-wrapper:nth-child(2) input').val(dateFin);
            }
        }else{
            $(this).parent().find('.input-field').removeClass('between');
        }
    });

    // cas filtre select avec impact sur un autre select
    $('body').delegate('.selectSearch:not(.options_filtre)', 'select2:select select2:unselect', function() {
        handleImpacts($(this));
    });

    function handleImpacts(element) {
        let impacts = $(element).data('impact');

        if(impacts !== undefined){
            // cas où il y ait plusieurs impacts
            impacts = impacts.split(',');

            let valeursSelect = $(element).val();
            const nameSelect = $(element).data('filtre');

            if(Array.isArray(valeursSelect)){
                valeursSelect = valeursSelect.join();
            }

            const data = {};
            data[nameSelect] = valeursSelect;

            // cas des relances, si on sélectionne toutes les agences, on doit pouvoir utiliser l'id de la société pour filtrer les commericiaux
            if($('.select-relance-societe').length > 0) {
                const influenceSociete = $('.select-relance-societe').val();

                if(influenceSociete != 'all'){
                    data["societe"] = influenceSociete;
                }
            }

            impacts.forEach(impact =>
                $.ajax({
                    type: 'GET',
                    url: '/filters/selects/'+impact,
                    data: data,
                    dataType: 'json',
                    success: function (resultat) {
                        const sortable = [];
                        for (const entry in resultat) {
                            // trim() ne fonctionne que sur une string, pas un array
                            if(typeof resultat[entry] === 'string'){
                                sortable.push([entry, resultat[entry].trim()]);
                            }else{
                                sortable.push([entry, resultat[entry]]);
                            }
                        }
                        sortable.sort(function(a, b) {
                            return (a[1] > b[1] ) ? 1 : -1;
                        });

                        // TODO remplacer resultat par sortable pour tri alpha, mais cause un bug
                        $('.option-'+impact).data('valeurs', resultat);
                        $('.select-'+impact).empty().trigger('change');

                        // cas selects dans les relances - impact sur agence et cmmmerciaux
                        let libelleTous = 'Tous';

                        if(impact == 'agence'){
                            libelleTous = 'Toutes';
                        }

                        if($('.select-relance-'+impact).length > 0){
                            const optionAll = new Option(libelleTous, 'all', false, false);
                            $('.select-'+impact).append(optionAll).trigger('change');
                            $('.select-'+impact).val('all').trigger('change');
                        }

                        for(const option in sortable){
                            if (typeof sortable[option][1] == 'object') {
                                // liste avec groupe
                                let optgroup = "<optgroup label='" + sortable[option][1]['label'] + "'>";
                                for(const index2 in sortable[option][1]['list']) {
                                    const newOption = "<option value='" + index2 + "'>" + sortable[option][1]['list'][index2] + "</option>";
                                    optgroup += newOption;
                                }
                                optgroup += "</optgroup>";
                                $('.select-'+impact).append(optgroup).trigger('change');
                            } else {
                                // liste simple
                                const newOption = new Option(sortable[option][1], sortable[option][0], false, false);
                                $('.select-'+impact).append(newOption).trigger('change');
                            }
                        }

                        if($('.select-relance-'+impact).length == 0) {
                            $('.select-' + impact).val(null).trigger('change');
                        }
                    }
                })
            );
        }
    }

    // enregistrement filtres AJAX
    $('.save-filtres').click(function() {
        const parametersUrlFiltre = globalcourtage.genereFiltersUrl();
        const urlFiltre = $(this).data('url-filtre');
        const filtres = $(this).data('filtres-save');

        $.ajax({
            type: 'post',
            url: urlFiltre + '/save-filters',
            data: {
                "_token": $('[name="csrf-token"]').attr('content'),
                'parametersUrlFiltre': parametersUrlFiltre,
                'urlFiltre': urlFiltre,
                'filtres-save': filtres,
            },
            dataType: 'json',
            success: function (result) {
                if(result){
                    M.toast({html: 'Les filtres ont bien été enregistrés'});
                }
            },
            error: function(result) {
                console.log(result);
            }
        });
    });

};

/* génère l'url construite des filtres */
$.fn.globalcourtage.genereFiltersUrl = function() {
    let urlFiltre = "?filtre=1";
    $('.input-filter').each(function() {
        let valeurFiltre = $(this).val();

        if(valeurFiltre === null){
            valeurFiltre = '';
        }

        const valeurLibelle = $(this).data('filtre');
        const typeFiltre = $(this).data('type');

        if (typeFiltre === 'checkbox'){
            if($(this).is(':checked')){
                valeurFiltre = 1;
            }else{
                valeurFiltre = 0;
            }
        }else if(typeFiltre === 'select'){
            if($('[name="inc_delete_'+valeurLibelle+'"]').is(':checked')){
                $('[name="inc_delete_'+valeurLibelle+'"]').val(1);
            }else{
                $('[name="inc_delete_'+valeurLibelle+'"]').val(0);
            }
            // if(valeurFiltre.length === 0) {
            //     valeurFiltre = $(this).data('selected');
            // }
        }else if (typeFiltre === 'date'){
            if(valeurFiltre.length > 0){
                if($('#comparaisonDate-'+valeurLibelle).val() === 'between') {
                    const valeurFiltreFin = $(this).parent().next().find('input.mask_date').val();
                    valeurFiltre = $('#comparaisonDate-'+valeurLibelle).val() + ':' + valeurFiltre + ':' + valeurFiltreFin;
                }else if($('#comparaisonDate-'+valeurLibelle).val() === '7derniersjours'){
                    const valeurFiltreFin = $(this).parent().next().find('input.mask_date').val();
                    valeurFiltre = $('#comparaisonDate-'+valeurLibelle).val() + ':' + valeurFiltre + ':' + valeurFiltreFin;
                }else if($('#comparaisonDate-'+valeurLibelle).val() === '30derniersjours'){
                    const valeurFiltreFin = $(this).parent().next().find('input.mask_date').val();
                    valeurFiltre = $('#comparaisonDate-'+valeurLibelle).val() + ':' + valeurFiltre + ':' + valeurFiltreFin;
                }else{
                    valeurFiltre = $('#comparaisonDate-'+valeurLibelle).val() + ':' + valeurFiltre;
                }
            }
        }else if (typeFiltre === 'numeric'){
            if(valeurFiltre.length > 0) {
                if ($('#comparaisonDate-' + valeurLibelle).val() === 'between') {
                    const valeurFiltreFin = $(this).next().val();
                    valeurFiltre = $('#comparaisonDate-' + valeurLibelle).val() + ':' + valeurFiltre + ':' + valeurFiltreFin;
                } else {
                    valeurFiltre = $('#comparaisonDate-' + valeurLibelle).val() + ':' + valeurFiltre;
                }
            }
        }

        // cas de tous les champs + checkbox (car length checkbox ne passe pas dans le test)
        // if(valeurFiltre.length > 0 || valeurFiltre === 1) {
            urlFiltre += "&" + valeurLibelle + "=" + valeurFiltre;
        // }
    });

    return urlFiltre;
};

/* toggle le bloc des filtres */
$.fn.globalcourtage.toggleFilters = function() {
    function filtresAffichage() {
        if($('.filtres').hasClass('full')){
            $('.filtres-options-append').fadeOut();
            $('.filtres-actions').fadeOut();

            $('.filtres').removeClass('full');

            $('.filtres-libelle h2').find('i').text('visibility_off');
        }else{
            $('.filtres-options-append').removeClass('hide').fadeIn();
            $('.filtres-actions').removeClass('hide').fadeIn();
            $('.filtres').addClass('full');

            $('.filtres-libelle h2').find('i').text('visibility');
        }
    }

    filtresAffichage();

    $('.filtres-libelle h2').click(function(){
        filtresAffichage();
    });

    $('.options_filtre').on('select2:select', function() {
        $('.filtres').addClass('full');
        $('.filtres-options-append').removeClass('hide').fadeIn();
        $('.filtres-actions').removeClass('hide').fadeIn();
        $('.filtres-libelle h2').find('i').text('visibility');

        // set le focus sur le l'input ajouté
        setTimeout(function() { $('.filtres-select input:last').focus(); }, 500);
    });
};

/* affiche un bloc à partir d'une checkbox */
$.fn.globalcourtage.showHideCheckbox = function() {
    function hideShowTarget(elem, cible) {
        if (cible.startsWith('acces-logiciel')) {
            // si on change la case a cocher d'acces utilisateur
            // on relance le validator pour qu'il applique ou retire les règles
            const $form = $('.' + cible).closest('form');
            const validator = $form.data('validator');
            if (validator) {
                validator.resetForm();
                validator.form();
            }
        }

        if (elem.is(':checked')) {
            $('.' + cible).removeClass('invisible');
        } else {
            $('.' + cible).addClass('invisible');
        }
    }

    $('.showHideCheckbox').on('change', function(){
        const cible = $(this).data('target');
        hideShowTarget($(this), cible);
    });

    $('.showHideCheckbox').each(function() {
        const cible = $(this).data('target');
        hideShowTarget($(this), cible);
    });
};

/* gère l'autocomplete des villes et code postaux basé sur l'API geo gouv */
let communes = null;
$.fn.globalcourtage.autocompleteZipcodeCity = function(context = null) {
    function sendItem(val, elem) {
        let villeString;
        let cpString;
        let departementString;

        if (elem.indexOf('[') > -1) {
            villeString = 'ville]';
            cpString = 'code_postal]';
            departementString = 'departement]';
        } else {
            villeString = 'ville';
            cpString = 'code_postal';
            departementString = 'departement';
        }

        const inputVille =  $('input[name="'+elem+villeString+'"]');
        const inputCodePostal = $('input[name="'+elem+cpString+'"]');
        const inputDepartement = $('input[name="'+elem+departementString+'"]');

        inputVille.val(val.slice(6)).siblings('label').addClass('active');

        // Trig un event 'input' pour que les composants Vue.js réagissent.
        inputVille[0].dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));

        // Si on est sur un champ département (déclaratif client)
        if (inputCodePostal.length == 0) {
            inputDepartement.val(val.slice(0,2)).siblings('label').addClass('active');
            inputDepartement[0].dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
        } else {
            inputCodePostal.val(val.slice(0,5)).siblings('label').addClass('active');
            inputCodePostal[0].dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
            if (inputVille.hasClass('maj_ptz') || inputCodePostal.hasClass('maj_ptz')) {
                let target = null;
                if(inputVille.data('ptz-target')) {
                    target = inputVille.data('ptz-target');
                } else {
                    target = inputCodePostal.data('ptz-target');
                }

                if (target != null) {
                    target = replaceAll(replaceAll(target, '[', '\\['), ']', '\\]');
                    updatePtz(inputCodePostal.val(), inputVille.val(), target);
                }
            }
        }
    }

    if ($('input[name*="ville"], input[name*="code_postal"], input[name*="departement"]', context).length > 0) {
        $('input[name*="ville"]', context).each(function(index, element) {
            $(element).autocomplete({
                data: {},
                onAutocomplete: function(txt) {
                    const nomElement = $(element).attr('name').split(new RegExp("(ville)"))[0];
                    sendItem(txt, nomElement);
                },
                limit: 30
            });
        });

        $('input[name*="code_postal"]', context).each(function(index, element) {
            $(element).autocomplete({
                data: {},
                onAutocomplete: function(txt) {
                    const nomElement = $(element).attr('name').split(new RegExp("(code_postal)"))[0];
                    sendItem(txt, nomElement);
                },
                limit: 30
            });
        });

        $('input[name*="departement"]', context).each(function(index, element) {
            $(element).autocomplete({
                data: {},
                onAutocomplete: function(txt) {
                    const nomElement = $(element).attr('name').split(new RegExp("(departement)"))[0];
                    sendItem(txt, nomElement);
                },
                limit: 30
            });
        });

        if (communes == null) {
            $.ajax({
                cache: true,
                dataType: 'json',
                type: 'GET',
                url: '/js/communes.json',
                success: function (resultat) {
                    communes = resultat;
                    updateCommunesData(context);
                }
            });
        } else {
            updateCommunesData(context);
        }
    }
};

const updatePtz = function(code_postal, ville, target) {
    $.ajax({
        type: 'get',
        url: '/get-ptz',
        data: {
            code_postal: code_postal,
            ville: ville
        },
        dataType: 'json',
        success: function (data) {
            $(target).val(data).trigger('change.select2');
        }
    });
};

const updateCommunesData = function(context) {
    $('input[name*="ville"]', context).each(function(index, element) {
        const instance = M.Autocomplete.getInstance($(element));
        if(instance !== undefined){
            instance.updateData(communes);
        }
    });

    $('input[name*="code_postal"]', context).each(function(index, element) {
        const instance = M.Autocomplete.getInstance($(element));
        if(instance !== undefined) {
            instance.updateData(communes);
        }
    });

    $('input[name*="departement"]', context).each(function(index, element) {
        const instance = M.Autocomplete.getInstance($(element));
        if(instance !== undefined) {
            instance.updateData(communes);
        }
    });
};

/* gère le context menu */
$.fn.globalcourtage.contextMenuTrigger = function() {
    if($('.context-menu-one').length > 0){
        $.contextMenu({
            selector: '.context-menu-one',
            callback: function(key, options) {
                const idModal = '#modal-rattacher-'+$(this).data('id');
                var instance = M.Modal.getInstance(document.querySelector(idModal));
                instance.open();
            },
            items: {
                "edit_user_entite": {name: "Rattacher l'interlocuteur à l'entité"}
            }
        });
    }
};

/* gère le compteur de SMS */
$.fn.globalcourtage.initForm = function () {
    $('.sms-counter').each(function() {
        const smsInput = $(this);
        smsInput.on('input', function () {
            smsCounter(smsInput);
        });
        smsCounter(smsInput);
    });

    function charToHex(char) {
        return ("0000" + char.toString(16)).slice(-4);
    }

    /**
     * Analyse la valeur d'un input et retourne dans l'élement cible le nb de caractères et de sms utilisés
     * @param {*} $input
     */
    function smsCounter ($input) {

        /**
         * Maximum characters in SMS with 7-bit encoding (3GPP TS 23.038 / GSM 03.38)
         */
        const MAXIMUM_CHARACTERS_7BIT_SINGLE = 160;

        /**
         * Maximum characters in SMS with 7-bit encoding with UDH (3GPP TS 23.040)
         */
        const MAXIMUM_CHARACTERS_7BIT_CONCATENATED = 153;

        /**
         * Maximum characters in SMS with UCS-2 encoding (3GPP TS 23.038 / GSM 03.38)
         */
        const MAXIMUM_CHARACTERS_UCS2_SINGLE = 70;

        /**
         * Maximum characters in SMS with UCS-2 encoding with UDH (3GPP TS 23.040)
         */
        const MAXIMUM_CHARACTERS_UCS2_CONCATENATED = 67;

        /**
         * Message cannot exceed size of 255 concatenated SMS (3GPP TS 23.040)
         */
        const MAXIMUM_CONCATENATED_SMS = 255;

        /**
         * @see https://en.wikipedia.org/wiki/GSM_03.38
         * @var string[] Printable characters in GSM 03.38 7-bit default alphabet
         *               0x1B deliberately excluded as it's used to escape to extension table
         */
        const GSM0338_BASIC = [
            '@'  , 'Δ' , ' ' , '0' , '¡' , 'P' , '¿' , 'p' ,
            '£'  , '_' , '!' , '1' , 'A' , 'Q' , 'a' , 'q' ,
            '$'  , 'Φ' , '"' , '2' , 'B' , 'R' , 'b' , 'r' ,
            '¥'  , 'Γ' , '#' , '3' , 'C' , 'S' , 'c' , 's' ,
            'è'  , 'Λ' , '¤' , '4' , 'D' , 'T' , 'd' , 't' ,
            'é'  , 'Ω' , '%' , '5' , 'E' , 'U' , 'e' , 'u' ,
            'ù'  , 'Π' , '&' , '6' , 'F' , 'V' , 'f' , 'v' ,
            'ì'  , 'Ψ' , "'" , '7' , 'G' , 'W' , 'g' , 'w' ,
            'ò'  , 'Σ' , '(' , '8' , 'H' , 'X' , 'h' , 'x' ,
            'Ç'  , 'Θ' , ')' , '9' , 'I' , 'Y' , 'i' , 'y' ,
            "\n" , 'Ξ' , '*' , ':' , 'J' , 'Z' , 'j' , 'z' ,
            'Ø'        , '+' , ';' , 'K' , 'Ä' , 'k' , 'ä' ,
            'ø'  , 'Æ' , ',' , '<' , 'L' , 'Ö' , 'l' , 'ö' ,
            "\r" , 'æ' , '-' , '=' , 'M' , 'Ñ' , 'm' , 'ñ' ,
            'Å'  , 'ß' , '.' , '>' , 'N' , 'Ü' , 'n' , 'ü' ,
            'å'  , 'É' , '/' , '?' , 'O' , '§' , 'o' , 'à'
        ];

        /**
         * @see https://en.wikipedia.org/wiki/GSM_03.38
         * @var string[] Printable characters in GSM 03.38 7-bit extension table
         */
        const GSM0338_EXTENDED = ['|', '^', '€', '{', '}', '[', '~', ']', '\\'];

        const message = $input.val();
        let encoding = '7-bit';
        let size = 0;
        for(const char of message) {
            if (GSM0338_BASIC.includes(char)) {
                size++;
            } else if(GSM0338_EXTENDED.includes(char)) {
                size += 2;
            } else {
                encoding = 'ucs-2';
            }
        }

        if (encoding == 'ucs-2') {
            size = 0;
            for(let c=0; c<message.length; c++) {
                const utf16 = message.charCodeAt(c);
                const utf16Hex = charToHex(utf16);

                size += Math.ceil(utf16Hex.length / 4);
            }
        }

        let singleSize = MAXIMUM_CHARACTERS_7BIT_SINGLE;
        let concatSize = MAXIMUM_CHARACTERS_7BIT_CONCATENATED;
        if (encoding === 'ucs-2') {
            singleSize = MAXIMUM_CHARACTERS_UCS2_SINGLE;
            concatSize = MAXIMUM_CHARACTERS_UCS2_CONCATENATED;
        }

        let messageCount = 1;
        let capacite = singleSize;
        if (size > singleSize) {
            messageCount = Math.ceil(size / concatSize);
            capacite = messageCount * concatSize;
        }

        $input.siblings('.helper-text').html(size + '/' + capacite + ' (' + messageCount + ' sms)');

        //const nbChar = $input.val().length;
        //const nbSms = Math.floor(nbChar / 160 + 1);
        //$input.siblings('.helper-text').html(nbChar + '/' + (160 * nbSms) + ' (' + nbSms + ' sms)')
    }

    $('.rich-text').each(function () {
        const options = {
            height: 200,
            resize:false,
            statusbar: false,
            toolbar: "code | undo redo removeformat | fontsizeselect | bold underline italic | alignleft aligncenter alignright alignjustify | bullist numlist | table | cut copy paste | searchreplace | image responsivefilemanager | forecolor | link | emoticons"
        };

        if ($(this).hasClass('rt-mail') || $(this).hasClass('rt-pdf') || $(this).hasClass('rt-high-height')) {
            options.height = 700;
        }

        if ($(this).hasClass('rt-medium-height')) {
            options.height = 300;
        }

        if ($(this).hasClass('rt-tags')) {
            options.toolbar += ' | tags';
        }

        if ($(this).hasClass('rt-resizable')) {
            options.resize = 'both';
            options.statusbar = true;
        }

        // if ($(this).hasClass('rt-preview-pdf')) {
        //     options.toolbar += ' | previewPDF';
        // }

        tinymce.init({
            selector: '#'+ $(this).attr('id'),
            language_url : '/js/tinymce/langs/fr_FR.js',
            language : 'fr_FR',
            forced_root_block : '',
            force_p_newlines : false,
            force_br_newlines : true,
            valid_elements : "*[*]",
            valid_children : "+body[style],+span[table],+span[div]",
            statusbar: options.statusbar,
            branding: false,
            toolbar_items_size: 'small',
            menubar: false,
            image_advtab: true,
            plugins: [
                "advlist autolink link image lists charmap print preview hr anchor pagebreak",
                "searchreplace visualblocks visualchars code fullscreen insertdatetime nonbreaking",
                "save table contextmenu directionality emoticons template paste textcolor previewPDF tags responsivefilemanager"
            ],
            toolbar1: options.toolbar,
            fontsize_formats: "8px 10px 12px 14px 18px 24px 36px",
            relative_urls : false,
            remove_script_host : false,
            link_assume_external_targets: true,
            height: options.height,
            external_filemanager_path: "/filemanager/",
            filemanager_title: "Bibliothèque",
            paste_as_text: true,
            resize: options.resize,
            external_plugins: {
                "responsivefilemanager": "/js/tinymce/plugins/responsivefilemanager/plugin.min.js",
                "filemanager": "../../filemanager/plugin.min.js"
            },
            content_css: '/css/pdf.css',
            setup: function (editor) {
                // Désactive le shortcut ctrl+s & command+s de tinymce
                // car il provoque un rechargment de page
                editor.on("init", function() {
                  editor.shortcuts.remove("meta+s", "", "");
                });
            },
        });
    });

    if ($('.input-tags').length > 0) {
        let dialogTags = null;
        let $modalTags = null;
        let $currentInput = null;

        $('.input-tags').each(function () {
            const $input = $(this);

            if (dialogTags === null) {
                $('#app').append('<div id="modal-tags" class="modal"><div class="modal-title"><h4>Insérer un tag</h4></div><div class="modal-content"></div></div>');

                $modalTags = $('#modal-tags');

                dialogTags = M.Modal.init(document.getElementById('modal-tags'), {
                    onOpenEnd: function () {
                        globalcourtage.modalDraggable(this);
                    }
                });

                $.ajax({
                    type: 'get',
                    url: '/communication/tags',
                    dataType: 'json',
                    success: function (response) {
                        let content = '<table class="list-tags"><thead><tr><th class="center-align">Nom</th><th>Infos</th></tr></thead><tbody>';
                        for (const key in response) {
                            content += '<tr><td class="center-align"><a href="javascript:;" data-value="[' + key + ']" class="tag">[' + key + ']</td><td>' + response[key] + '</td></tr>';
                        }
                        content += '</tbody></table>';

                        $modalTags.find('.modal-content').html(content);

                        $modalTags.find('.list-tags').dataTable({
                            language: {
                                url: "/js/datatables/translations/fr.json"
                            },
                            deferRender: true,
                            stateSave: true,
                            retrieve: true,
                            aLengthMenu: [[10, 25, 100, -1], [10, 25, 100, "Tous"]],
                            responsive: true,
                            pageLength: 10
                        });
                    }
                });
            }

            $input.siblings('label').append($('<a class="margin-l-10" href="javascript:">Insérer un tag</a>').on('click', function () {
                $currentInput = $input;

                dialogTags.open();
            }));
        });

        $modalTags.on('click', '.tag', function () {
            $currentInput.val($currentInput.val() + $(this).data('value'));
            M.updateTextFields();

            if ($currentInput.hasClass('sms-counter')) {
                smsCounter($currentInput);
            }

            dialogTags.close();
        });
    }
};

/* duplique une adresse */
$.fn.globalcourtage.dupliquerAdresse = function() {
    if($('#rue').length > 0 && $('#code_postal').length > 0 && $('#ville').length > 0){
        $('.dupliquer_adresse').click(function() {
            $('#facturation_rue').val($('#rue').val()).siblings('label').addClass('active');
            $('#facturation_code_postal').val($('#code_postal').val()).siblings('label').addClass('active');
            $('#facturation_ville').val($('#ville').val()).siblings('label').addClass('active');
        });
    }
};

/* Initialise chaque element de type copier_adresse.
 * Lors du changement du Select, on rend possible la Copie de l'adresse
*/
$.fn.globalcourtage.fillDataCopierAdresse = function()
{
    $('.copier_adresse').each(function() {
        const $btnCopierAdresse = $(this);

        // récupère le ou les éléments qui déclenche un changement de contenu de la copie.
        const triggers = $(this).attr('data-triggers');

        const $selectTriggerCopierAdresse = $('select[name="' + triggers +'"]');

        // surveille les changements pouvant survenir sur ces éléments
        $selectTriggerCopierAdresse.on('change', function() {
            const $selectTriggerCopierAdresse = $(this);
            onCopierAdresseSelectChange($btnCopierAdresse, $selectTriggerCopierAdresse);
        });

        // Lance un premier event de changement au chargement de la page pour initialiser le composant 'copier_adresse'
        onCopierAdresseSelectChange($btnCopierAdresse, $selectTriggerCopierAdresse);
    });
};

/**
 * Event: select surveillé par un bouton de copie a changé.
 * Affiche le bouton de Copie d'adresse et remplit les datas associées
 * @param {*} button le bouton copier impacté par le changement
 * @param {*} select le select sur lequel a eu lieu le changement
 */
const onCopierAdresseSelectChange = function(button, select) {
    // Si l'entité a une entité parent dont l'adresse est copiable
    if(button.data('copiable')) {
        // l'entité prise par défaut si aucune selection
        const defautEntityType = button.data('defaut-entity-type');
        const defautEntityId = button.data('defaut-entity_id');

        // Si le select a une selection valide
        if (select.val() > 0) {
            // on place les éléments de copie sur l'entité ciblé par le select.
            button.data('entity-type', button.data('initial-entity-type'));
            button.data('entity_id', select.val());
            button.show();
        } else if(defautEntityType && defautEntityId) {
            // sinon si entité par défaut, on place les éléments de copie dessus
            button.data('entity-type', defautEntityType);
            button.data('entity_id', defautEntityId);
            button.show();
        } else {
            // sinon pas de copie possible.
            button.hide();
        }

        // Gestion du tooltip du bouton selon l'entité configurée
        const buttonEntityType = button.data('entity-type');
        let tooltip = "Copier l'adresse de ";
        const entityTypeTooltips = {
            'societe' : "la société",
            'agence' : "l'agence",
            'agence_apporteur': "l'agence apporteur",
            'apporteur': "l'apporteur",
            'banque': "la banque",
            'banque_agence': "l'agence bancaire"
        };

        tooltip += entityTypeTooltips[buttonEntityType];

        button.attr('data-tooltip', tooltip);
        button.tooltip();
    }
};

/* Récupère les éléments d'une Adresse et remplit les champs du formulaire associé */
$.fn.globalcourtage.copierAdresse = function() {
    $('.copier_adresse').on('click', function() {
        var adresseCibles = $(this).data("adresseCibles");
        $.ajax({
            type: 'GET',
            url: '/ajax/adresse?id=' + $(this).data('entity_id') + '&entityType=' + $(this).data('entityType') ,
            success: function (adresse) {
                if (adresse) {
                    for (const [key, value] of Object.entries(adresseCibles)) {
                        $(value).val(adresse[key]).siblings('label').addClass('active');
                    }
                }
                // On rend visible le bouton permettant de dupliquer l'adresse dans la partie Adresse de facturation
                $.fn.globalcourtage.isAdresseCopiable();
            },
            error: function(data) {
                console.log('erreur');
                console.log(data);
            }
        });
    });
};

// Quand on modifie un input de l'Adresse, on regarde si cette Adresse est copiable pour la partie Adresse de facturation
$('.adresse :input').change(function() {
    $.fn.globalcourtage.isAdresseCopiable();
});

/* On checke s'il y a un élément copiable depuis la partie Adresse. Si c'est le cas, on affiche le bouton permettant de la copier */
$.fn.globalcourtage.isAdresseCopiable = function() {
    $('.adresse :input').each(function () {
        if($(this).val().length > 0) {
            $('.dupliquer_adresse').show();
            return false;
        } else {
            $('.dupliquer_adresse').hide();
        }
    });
};

/* gère la pagination en ajax */
$.fn.globalcourtage.handlePagination = function() {
    if($('.load-more-pagination').length > 0) {
        $('body').on('click', '.load-more-pagination', function (e) {
            $('.overlay-ajax-loader').removeClass('hide');
            $('.load-more-pagination').attr('disabled', true); // previent les multiples clics sur le bouton
            e.preventDefault();
            const url = $(this).data('href');

            const colonnesVisibles = $('.endless-pagination').find('thead th:visible');
            const idsVisibles = [];
            colonnesVisibles.each(function() {
                idsVisibles.push($(this).data('id'));
            });

           $.get(url, function (data) {
               $('.load-more-pagination').attr('disabled', false);
               if(data.next_page == undefined) {
                    $('.load-more-pagination').hide();
               }
               const newData = $.parseHTML(data.donnees);
               $('.endless-pagination tbody, .endless-pagination .pagination-content').append(newData);
               $('.load-more-pagination').data('href', data.next_page);
               $('.overlay-ajax-loader').addClass('hide');
               $('.modal').modal({
                   onOpenEnd:function() {
                       globalcourtage.modalDraggable(this);
                   }
               });

               // cas particulier du listing dossiers où on choisit les colonnes à afficher
               $('.endless-pagination.listing-dossiers').find('tbody td:not(:first-child)').addClass('hide');

               for(const element in idsVisibles) {
                   $('.endless-pagination.listing-dossiers').find('tbody td[data-id="' + idsVisibles[element] + '"]').removeClass('hide');
               }

               // fin cas particulier dossiers

               $("html, body").animate({ scrollTop: document.body.scrollHeight }, 1000);

               $.fn.globalcourtage.onHandlePaginationEnd(newData);

               // cas des logs webservices
               $.fn.globalcourtage.beautifyJsonFormat();
               $.fn.globalcourtage.beautifyXmlFormat();
               $.fn.globalcourtage.initScrollableTable();
            });
        });
    }
};

$.fn.globalcourtage.onHandlePaginationEnd = function(context) {
    $('.tooltipped', context).tooltip();
};

/* gère le toggle des box des forms */
$.fn.globalcourtage.toggleBoxForm = function() {
    if($('.toggle-box').length > 0 ){
        $('.toggle-box').click(function(){
            // clic sur le header complet
            if($(this).hasClass('heading-box')){
                $(this).toggleClass('open');
                $(this).next('.box-aside').slideToggle();
            }
            // clic sur la flèche
            else{
                $(this).parents('.heading-box').toggleClass('open');
                $(this).parents('.heading-box').next('.box-aside').slideToggle();
            }
        });
    }
};

$.fn.globalcourtage.handleListingColumns = function() {
    function updateColumnsTableDropdown(tableauColonnes) {
        $('.endless-pagination thead th, .endless-pagination tbody td').each(function() {
            const id = $(this).data('id');

            if(id !== undefined) {
                if(tableauColonnes.indexOf(parseInt(id)) === -1){
                    $(this).addClass('hide');
                }else{
                    $(this).removeClass('hide');
                }
            }
        });

        $('#dropdown-columns ul li a').each(function(){
            const target = $(this).data('target');

            if(target !== undefined) {
                if(tableauColonnes.indexOf(parseInt(target)) === -1){
                    $(this).removeClass('disabled');
                }else{
                    $(this).addClass('disabled');
                }
            }
        });

        $.fn.globalcourtage.initScrollableTable();
    }

    function activesElementsColonnes(){
        const activesElement = [];

        $('#dropdown-columns ul li a').each(function(){
            if($(this).hasClass('disabled')) {
                activesElement.push($(this).data('target'));
            }
        });

        // tri du tableau
        activesElement.sort(function(a, b) {
            return a - b;
        });

        return activesElement;
    }

    function handleActiveButtonsTri(defaultColonnes, allColonnes) {
        $('#dropdown-columns .btn-aff').removeClass('active');

        if(JSON.stringify(activesElementsColonnes()) == JSON.stringify(defaultColonnes)) {
            $('#dropdown-columns .btn-aff.aff-reduit-dossiers').addClass('active');
        }else if(JSON.stringify(activesElementsColonnes()) == JSON.stringify(allColonnes)){
            $('#dropdown-columns .btn-aff.aff-complet-dossiers').addClass('active');
        }else{
            $('#dropdown-columns .btn-aff.aff-perso-dossiers').addClass('active');
        }

        $.fn.globalcourtage.initScrollableTable();
    }

    if($('.aff-reduit-dossiers').length > 0 ){
        const defaultColonnes = $('#defaultColonnes').val().split(',').map(Number);
        const allColonnes = $('#allColonnes').val().split(',').map(Number);

        // tris des tableaux
        defaultColonnes.sort(function(a, b) {
            return a - b;
        });

        allColonnes.sort(function(a, b) {
            return a - b;
        });

        const entiteCookie = $('#entite-cookie').val();

        // toggle des colonnes
        $('#dropdown-columns ul li a').click(function(){
            const target = parseInt($(this).data('target'));

            if($(this).hasClass('disabled')){
                $(this).removeClass('disabled');
            }else{
                $(this).addClass('disabled');
            }

            $('.endless-pagination thead th, .endless-pagination tbody td').each(function() {
                if(parseInt($(this).data('id')) === target) {
                    if ($(this).is(':visible')) {
                        $(this).addClass('hide');
                    } else {
                        $(this).removeClass('hide');
                    }
                }
            });

            handleActiveButtonsTri();
        });

        // btn aff réduit
        $('.aff-reduit-dossiers').click(function(){
            updateColumnsTableDropdown(defaultColonnes);
        });

        // btn aff complet
        $('.aff-complet-dossiers').click(function(){
            updateColumnsTableDropdown(allColonnes);
        });

        // btn aff perso
        $('.aff-perso-dossiers').click(function(){
            if (Cookies.get('colonnes-actives-'+entiteCookie+'-choix') !== undefined) {
                const cookieColonnes = Cookies.get('colonnes-actives-'+entiteCookie+'-choix').split(',');
                let colonnes = [];
                $(cookieColonnes).each(function (index, cookieColonne) {
                    const colonne = cookieColonne.toString().split(':');

                    if(colonne[2] === 'active') {
                        colonnes.push(colonne[1]);
                    }
                });

                colonnes = colonnes.map(Number);

                updateColumnsTableDropdown(colonnes);
            }
        });

        // si on enregistre le choix dans le dropdown, on set un cookie pour les colonnes sélectionnées
        $('.save-choice').click(function(){
            let colonnesFinales = [];

            $('#dropdown-columns ul li').each(function() {
                let stringColonne = '';
                const index = $(this).index() + 1;

                stringColonne += index + ':' + $(this).find('a').data('target') + ':';

                if($(this).find('a').hasClass('disabled')){
                    stringColonne += 'active';
                }else{
                    stringColonne += 'disabled';
                }

                colonnesFinales.push(stringColonne);
            });

            colonnesFinales = colonnesFinales.join(',');

            Cookies.set('colonnes-actives-'+entiteCookie+'-choix', (colonnesFinales ? colonnesFinales : null), { expires: 90 });
            document.location.reload();
            $('.toastOrderColumnsTrigger').trigger('click');
        });

        // event du dropdown
        $(".dropdown-trigger-left").dropdown({
            alignment: 'left',
            constrainWidth: false,
            coverTrigger: false,
            closeOnClick: false,
            onCloseStart: function() {
                let colonnesActives = [];
                $('.endless-pagination thead th').each(function() {
                    if($(this).is(':visible') && $(this).data('id') !== undefined){
                        colonnesActives.push($(this).data('id'));
                    }
                });

                colonnesActives = colonnesActives.join(',');
                Cookies.set('colonnes-actives-'+entiteCookie, (colonnesActives ? colonnesActives : null), { expires: 90 });
            }
        });

        // gestion ordre de la liste des colonnes
        $('#dropdown-columns ul').sortable({
            helper: 'clone'
        });

        // gestion active des boutons de choix de tris
        $('#dropdown-columns .btn-aff').click(function(){
            $('#dropdown-columns .btn-aff').removeClass('active');
            $(this).addClass('active');
        });

        handleActiveButtonsTri(defaultColonnes, allColonnes);

    }
};

/**
 * Gère le formatage des nombres après un chargenement de page et avant un submit.
 *
 * @param context spécifie le contexte surlequel appliquer le formatage
 */
$.fn.globalcourtage.formatNumbers = function(context = null)
{
    formatNumbersAfterLoad(context);

    // surveille les formulaires pour formatter avant le submit
    $('form', context).each(function () {
        const $form = $(this);
        $form.on('submit', function () {
            // on s'assure que la validation ne retourne pas d'erreur
            if ($form.valid() !== false) {
                // formatte les données et autorise le submit
                formatNumbersBeforeSubmit($form);
                return true;
            }
            return false;
        });
    });
};

/**
 * Formate les nombres après un chargement de page
 * @param {*} context spécifie le contexte surlequel appliquer le formatage
 */
const formatNumbersAfterLoad = function (context) {
    // liste des formattages au chargement et à la saisie
    const formatters = {
        '.mask-decimal': ['formatDecimal', []],
        '.mask-decimal-taux': ['formatDecimal', [4]],
        '.mask-int': ['formatInt', []],
        // version nullable
        '.mask-decimal-nullable': ['formatDecimal', [2, true]],
        '.mask-decimal-taux-nullable': ['formatDecimal', [4, true]],
        '.mask-int-nullable': ['formatInt', [true]]
    };

    for (const formatterSelector in formatters) {
        const formatterParams = formatters[formatterSelector];
        const formatterFunctionName = formatterParams[0];
        const formatterFunctionParams = formatterParams[1];

        $(formatterSelector, context).each(function () {
            globalcourtage[formatterFunctionName]($(this), ...formatterFunctionParams);
        });

        $(formatterSelector, context).on('blur', function () {
            globalcourtage[formatterFunctionName]($(this), ...formatterFunctionParams);
        });
    }
};
$.fn.globalcourtage.formatNumbersAfterLoad = formatNumbersAfterLoad;

/**
 * Formatte les éléments d'un formulaire avant un submit
 * @param {*} context spécifie le contexte surlequel appliquer le formatage
 */
const formatNumbersBeforeSubmit = function (context) {
    // liste des formattages à l'enregistrement
    const savers = {
        '.mask-decimal': ['formatDecimalForBdd', []],
        '.mask-decimal-taux': ['formatDecimalForBdd', []],
        '.mask-int': ['formatIntForBdd', []],

        '.mask-decimal-nullable': ['formatDecimalForBdd', [true]],
        '.mask-decimal-taux-nullable': ['formatDecimalForBdd', [true]],
        '.mask-int-nullable': ['formatIntForBdd', [true]]
    };

    for (const saverSelector in savers) {
        const saverParams = savers[saverSelector];
        const saverFunctionName = saverParams[0];
        const saverFunctionParams = saverParams[1];

        $(saverSelector, context).each(function() {
            const valeur = globalcourtage[saverFunctionName]($(this), ...saverFunctionParams);
            $(this).val(valeur);
        });
    }
};
$.fn.globalcourtage.formatNumbersBeforeSubmit = formatNumbersBeforeSubmit;

$.fn.globalcourtage.cliquableRow = function() {
    $('body').delegate('.cliquable-row td:not(:first-child, :has(a))', 'click', function() {
       const target = $(this).parent().data('href');
       window.open(target, '_blank');
    });
};

$.fn.globalcourtage.cliquableCard = function() {
    $('body').delegate('.cliquable-card', 'click', function() {
        const target = $(this).parent().data('href');
        window.location.replace(target);
    });
};

$.fn.globalcourtage.formatDecimal = function(element, precision = 2, nullable = false) {
    let valeur;

    // Récupère la valeur présente
    if (element.prop('tagName') === 'INPUT') {
        valeur = element.val();
    } else {
        valeur = element.text();
    }

    // gestion valeur vide nullable
    if (valeur === '' && nullable) {
        valeur = null;
        if (element.prop('tagName') === 'INPUT') {
            element.val(valeur);
        } else {
            element.text(valeur);
        }
        return;
    }

    // sinon converti la valeur
    valeur = valeur.replace(',', '.').split(' ').join('');
    valeur = accounting.formatNumber(valeur, {
        precision: precision,
        thousand: ' ',
        decimal: ','
    });

    // conversion impossible
    if (valeur === 'NaN,undefined') {
        // 0 par défaut
        valeur = accounting.formatNumber(0, {
            precision: precision,
            decimal: ','
        });

        // ou null si autorisé
        if (nullable) {
            valeur = null;
        }
    }

    // applique la valeur formatée
    if (element.prop('tagName') === 'INPUT') {
        element.val(valeur);
    } else {
        element.text(valeur);
    }
};

$.fn.globalcourtage.formatInt = function(element, nullable = false) {
    let valeur;

    if(element.prop('tagName') === 'INPUT'){
        valeur = element.val().split(' ').join('');
    }else{
        valeur = element.text().split(' ').join('');
    }

    // gestion valeur vide nullable
    if (valeur === '' && nullable) {
        valeur = null;
        if (element.prop('tagName') === 'INPUT') {
            element.val(valeur);
        } else {
            element.text(valeur);
        }
        return;
    }

    valeur = accounting.formatNumber(valeur, {
        precision: 0,
        thousand: ' '
    });

    if(valeur === 'NaN'){
        if(element.prop('tagName') === 'INPUT') {
            element.val(accounting.formatNumber(0, {
                    precision: 0,
                })
            );
        }else{
            element.text(accounting.formatNumber(0, {
                    precision: 0,
                })
            );
        }
    }else{
        if(element.prop('tagName') === 'INPUT') {
            element.val(valeur);
        }else{
            element.text(valeur);
        }
    }
};

/**
 * Retourne la valeur d'un élément, convertie en nombre.
 *
 * 0 est retourné si la valeur de l'élément n'a pas pu être convertie. ou null si nullable est à true.
 * @param {*} element
 * @param {bool} nullable autorise la valeur null au lieu de 0 pour des éléments non renseignés.
 * @returns
 */
$.fn.globalcourtage.formatDecimalForBdd = function(element, nullable = false) {
    let valeur;
    if (element.prop('tagName') === 'INPUT') {
        valeur = element.val();
    } else {
        valeur = element.text();
    }

    if (valeur == '' && nullable) {
        return null;
    }

    valeur = valeur.replace(',', '.').split(' ').join('');
    return Number(valeur);
};

$.fn.globalcourtage.formatIntForBdd = function(element) {
    let valeur;
    if(element.prop('tagName') === 'INPUT') {
        valeur = element.val().split(' ').join('');
    }else{
        valeur = element.text().split(' ').join('');
    }
    return Number(valeur);
};

/* calcule le total des inputs voulus d'un tableau */
$.fn.globalcourtage.calculTotal = function(item) {
    const totaux = {};
    let container = item + '-table';

    if(item == 'pret-en-cours'){
        container = item + '-wrapper';
    }

    $('.'+container+' .field-for-total').each(function() {
        const target = $(this).data('field');

        if(totaux[target] === undefined){
            totaux[target] = 0;
        }

        let number;

        if($(this).prop('tagName') === 'INPUT'){
            number = $(this).val().replace(',', '.');
        }else{
            number = $(this).text().replace(',', '.');
        }

        number = number.split(' ').join('');

        if(isNaN(number)){
            totaux[target] += Number(0);
        }else{
            totaux[target] += Number(number);
        }
    });

    $.each(totaux, function(target) {
        let valeurTotal = parseFloat(totaux[target]).toFixed(2);

        valeurTotal = accounting.formatNumber(valeurTotal, {
            precision: 2,
            thousand: ' ',
            decimal: ','
        });

        // cas particulier des ressources
        if(item == 'revenus'){
            $('.'+item+'-box .total-value-'+target).val(valeurTotal);
        }else{
            $('.'+item+'-table .total-value-'+target).val(valeurTotal);
        }
    });
};

$.fn.globalcourtage.triggerCalculTotalTable = function(items) {
    items.forEach(item => {
        globalcourtage.calculTotal(item);

        $('body').on('blur', '.' + item + '-table .field-for-total', function () {
            globalcourtage.calculTotal(item);
        });
    });
};


$.fn.globalcourtage.openSideNav = function(items) {
    items.forEach(item => {
        $('.button-'+item).click(function () {
            $('.sidecontent').removeClass('open');

            if($(this).hasClass('open')){
                $(this).removeClass('open');
                $('.sidecontent-'+item).removeClass('open');
            }else{
                $('.actions-propos a, .right-menu-dossier a').removeClass('open');
                $(this).addClass('open');
                $('.sidecontent-'+item).addClass('open');
            }

            if($(this).hasClass('unfloating-button-container')){
                if($('#app').hasClass('opened-right')){
                    $('#app').removeClass('opened-right');
                }else{
                    $('#app').addClass('opened-right fullwidth');
                    $('#slide-out').addClass('smallnav');
                    $('.sidenav-close i').text('menu');
                }
            }else{
                $('#app').removeClass('opened-right');
            }
        });
    });

    $(window).scroll(function(){
       const offsetTop = $(document).scrollTop();

       if(offsetTop > 100){
           $('.sidecontent').addClass('topFixed');
       }else{
           $('.sidecontent').removeClass('topFixed');
       }
    });
};

$.fn.globalcourtage.closeSideNav = function() {
    $('.close-div').click(function() {
        $('.actions-propos a, .right-menu-dossier a').removeClass('open');
        $(this).parents('.sidecontent').removeClass('open');
        $('#app').removeClass('opened-right');
    });
};

/* gère le fait de rendre actif les inputs, textarea et select sur les lignes nouvellement créées */
$.fn.globalcourtage.activateRowInputs = function(newRow, item, index) {
    newRow.find('input, select, textarea').prop('disabled', false);
    newRow.find('input, select, textarea, label, a, i, span, div').each(function () {
        let name = $(this).attr('name');
        let id = $(this).attr('id');
        let forAttr = $(this).attr('for');
        let value = $(this).attr('value');
        let dataLine = $(this).attr('data-line');
        let target = $(this).attr('data-target');

        if (name !== undefined) {
            name = name.replace('new-' + item + '-0', 'new-' + item + '-' + index);
            $(this).attr('name', name);
        }

        if (id !== undefined) {
            id = id.replace('new-' + item + '-0', 'new-' + item + '-' + index);
            $(this).attr('id', id);
        }

        if (forAttr !== undefined) {
            forAttr = forAttr.replace('new-' + item + '-0', 'new-' + item + '-' + index);
            $(this).attr('for', forAttr);
        }

        if (value !== undefined) {
            value = value.replace('new-' + item + '-0', 'new-' + item + '-' + index);
            $(this).attr('value', value);
        }

        if (dataLine !== undefined) {
            dataLine = dataLine.replace('new-' + item + '-0', 'new-' + item + '-' + index);
            $(this).attr('data-line', dataLine);
        }

        if (target !== undefined) {
            target = target.replace('new-' + item + '-0', 'new-' + item + '-' + index);
            $(this).attr('data-target', target);
        }
    });

    globalcourtage.autocompleteZipcodeCity(newRow);
};

// gère l'ajout des lignes de formulaire
$.fn.globalcourtage.addNewItemLine = function(items) {
    items.forEach(item => {
        const lineInputs = $('.' + item + '-row input, .' + item + '-row select, .' + item + '-row textarea');
        lineInputs.prop('disabled', true);
        let index = 0;
        let newRow;

        $('body').delegate('.add_line_' + item, 'click', function () {
            index += 1;

            if(item == 'revenus' ){
                newRow = $(this).parents('.client-ressources').find('.' + item + '-row').clone();
                newRow.appendTo($(this).parents('.client-ressources').find('.' + item + '-group')).addClass('line-row').removeClass('hide ' + item + '-row');
            }else if(item == 'reserves'){
                newRow = $(this).closest('.modal').find('.' + item + '-row').clone();
                newRow.appendTo($(this).parents('.modal').find('.' + item + '-table')).addClass('line-row').removeClass('hide ' + item + '-row');
            }else{
                newRow = $('.' + item + '-row').clone();
                newRow.appendTo($('.' + item + '-table')).addClass('line-row').removeClass('hide ' + item + '-row');
            }

            globalcourtage.activateRowInputs(newRow, item, index);
            formatNumbersAfterLoad(newRow);

            if(item == 'revenus'){
                globalcourtage.reinitSelect2($('.' + item + '-group tr:not(.' + item + '-row)'));
            }else{
                globalcourtage.reinitSelect2($('.' + item + '-table tr:not(.' + item + '-row)'));
            }

            // ouvre le bloc si celui ci est fermé
            if ($('#container-' + item + ' .box-aside').is(':hidden')) {
                $('#' + item + ' .toggle-box').trigger('click');
            }

            globalcourtage.resetDatePicker();
            globalcourtage.initDatePicker();

            $('.multiple-select-dropdown input').addClass('filled-in');

            // maj du compteur
            if($('#compteur-'+item).length > 0){
                const comptItems = $('.'+item+'-table .line-row').length;
                $('#compteur-'+item+' .badge').text(comptItems);
            }
        });
    });
};

// gère la suppression des lignes de form
$.fn.globalcourtage.deleteLine = function() {
    $('body').delegate('.delete-line', 'click', function() {
        const item = $(this).closest('table').data('item');
        const rowParent = $(this).closest('.line-row');
        const table = $(this).closest('table');

        // cas des lignes de prêt avec détail
        if(rowParent.next('.detail-row-table').length > 0) {
            rowParent.next('.detail-row-table').remove();
        }

        // on gère les index des paliers forcés
        rowParent.find('.paliersforces-table .line-row').each(function(indexPalier, valeur){
            indexPalier += 1;
            $(this).find('.paliersforces-number').text(indexPalier);
        });

        rowParent.remove();

        // cas des clients - cumul imposables
        const target = $(this).data('target');
        if(target !== undefined){
            $('.client-ressources-'+target).remove();
            $('.comptes-line-'+target).remove();
            $('.credits-line-'+target).remove();
        }

        // cas des emplois
        if(table.find($('.emplois-group .profession-liberale-row')).length == 0){
            table.find('.bloc-tbody-chiffres-affaires').addClass('hide');
            table.find('.bloc-tbody-benefices').addClass('hide');

            // cas des selects revenus - on retire l'emploi de la liste des revenus liés
            const professionLibelle = rowParent.find('.profession-text').text();
            const selectEmploisRevenus = table.find('.select-emplois-liaison');
            if(selectEmploisRevenus !== undefined){
                $(selectEmploisRevenus).find('option').each(function() {
                    if($(this).text() == professionLibelle){
                        $(this).remove();
                    }
                });

                selectEmploisRevenus.trigger('change.select2');
            }
        }

        // on recalcule les totaux du tableaux
        globalcourtage.calculTotal(item);

        // maj du compteur
        if($('#compteur-'+item).length > 0){
            const comptItems = $('.'+item+'-table .line-row').length;
            $('#compteur-'+item+' .badge').text(comptItems);
        }

        // PropositionPret.actualisePlanRemboursement();
    });
};

// gère la valeur par défaut du prefixe compta agence si compta société non sélectionnée
$.fn.globalcourtage.generatePrefixeComptaAgence = function() {
    const comptaPrefixeAgenceInput = $('.compta-prefixe-agence');
    const checkboxComptaSociete = $('#has_compta_facture_societe');
    const comptaFctFacture = $('#compta_fonctionnement_facture');

    checkboxComptaSociete.click(function(){
       if($(this).prop('checked') === false){
           if(comptaPrefixeAgenceInput.val() === ''){
               comptaPrefixeAgenceInput.val('%nom_societe-%nom_agence-%y-');
               comptaPrefixeAgenceInput.siblings('label').addClass('active');
           }
       }else{
           comptaPrefixeAgenceInput.val('');
       }
    });
};

// gère les exports checkbox des listings (principalement compta)
$.fn.globalcourtage.exportCheckboxesListing = function() {
    $('.export-all').click(function() {
        let countLinesChecked = 0;

        $(this).toggleClass('active');
        $('.export-line').each(function(){
            if($('.export-all').hasClass('active')){
                $('.export-line').prop('checked', true);
                countLinesChecked++;
            }else{
                $('.export-line').prop('checked', false);
            }
        });

        if(countLinesChecked > 0){
            $('.count-selected-checked').text(countLinesChecked+' lignes cochées');
        }else{
            $('.count-selected-checked').text('');
        }
    });

    $('body').delegate('.export-line', 'click', function() {
        let countLinesChecked = 0;

        $('.export-line').each(function(){
            if($(this).prop('checked') === true){
                countLinesChecked++;
            }
        });

        if(countLinesChecked > 0){
            $('.count-selected-checked').text(countLinesChecked+' lignes cochées');
        }else{
            $('.count-selected-checked').text('');
        }
    });
};

// gère l'export Excel et PDF des listings
$.fn.globalcourtage.exportPdfListing = function() {
    ['pdf', 'excel', 'csv'].forEach(dataType => {
        $('.export-'+dataType+'-listing').on('click', function() {
            const $buttonExport = $(this);
            const $loader = $(this).parent().find('.loading-'+dataType+'-export');

            const parametres = $(this).data('parametres');

            showExportLoading($buttonExport, $loader);

            const entite = $(this).data('entite');

            // gestion selection de lignes
            let checked_lines = [];
            $('.export-line').each(function() {
                if ($(this).prop('checked') == true) {
                    checked_lines.push($(this).data('id'));
                }
            });
            checked_lines = checked_lines.join(',');

            // format d'export
            let format = dataType;
            if (format == 'excel') {
                format = 'xlsx';
            }

            $.ajax({
                type: 'POST',
                url: '/' + entite + '/export?export=1&'+parametres,
                data: {
                    _token: $('[name="csrf-token"]').attr('content'),
                    format: format,
                    'checked-lines': checked_lines
                },
                success: function (downloadUrl) {
                    hideExportLoading($buttonExport, $loader);
                    window.open(downloadUrl, '_blank');
                },
                error: function(data) {
                    hideExportLoading($buttonExport, $loader);
                    alert('Une erreur s\'est produite pendant l\'export.');
                    console.log('erreur');
                    console.log(data);
                }
            });
        });
    });

    function showExportLoading($button, $loader)
    {
        if ($button.hasClass('btn-floating')) {
            $button.find('.loading').removeClass('hide');
            $button.find('.icon').addClass('hide');
        } else {
            $loader.removeClass('hide');
            $button.hide();
        }
    }

    function hideExportLoading($button, $loader)
    {
        if ($button.hasClass('btn-floating')) {
            $button.find('.loading').addClass('hide');
            $button.find('.icon').removeClass('hide');
        } else {
            $loader.addClass('hide');
            $button.show();
        }
    }
};

$.fn.globalcourtage.initSideNavs = function() {
    if($('.sidecontent-contacts').length > 0){
        globalcourtage.openSideNav(['contacts']);
    }
    if($('.sidecontent-config-relances').length > 0){
        globalcourtage.openSideNav(['config-relances']);
    }
};

$.fn.globalcourtage.handleFilledInputsSelects = function() {
    $('tr:not(.totaux-row) input[type=text]:not(.select-dropdown), tr:not(.totaux-row) textarea').each(function(){
        if($(this).val() !== ''){
            $(this).addClass('filled');
        }
    });

    $('tr:not(.totaux-row) input[type=text]:not(.select-dropdown), tr:not(.totaux-row) textarea').blur(function(){
        if($(this).val() !== ''){
            $(this).addClass('filled');
        }else{
            $(this).removeClass('filled');
        }
    });
};

$.fn.globalcourtage.beautifyJsonFormat = function() {
    if($('.json-ugly').length > 0) {
        $('.modal-flux .json-ugly').each(function(){
            const uglyJson = $(this).html();
            $(this).next('.json-beautify').jsonViewer(JSON.parse(uglyJson), { withQuotes: true});
        });
    }
};

$.fn.globalcourtage.beautifyXmlFormat = function() {
    if($('.ugly-xml').length > 0) {
        $('.ugly-xml').each(function(){
            const beginXml = '<root>';
            const uglyXml = $(this).html();
            let fullXml = beginXml + uglyXml;
            fullXml = formatxml(fullXml, {
                indentation: '  ',
                collapseContent: true,
                lineSeparator: '\n'
            });

            $(this).next('textarea').text(fullXml);
            $(this).hide();
        });
    }
};

$.fn.globalcourtage.toggleLineDetail = function() {
    if($('.show-more-button').length > 0) {
        $('body').delegate('.show-more-button', 'click', function(){
            const detailRow = $(this).closest('tr').next('.detail-row-table');

            if(detailRow.is(':visible')){
                $(this).find('i').text('add');
                detailRow.addClass('hide');
            }else{
                $(this).find('i').text('remove');
                detailRow.removeClass('hide');
            }
        });
    }
};

/* gère le chargement des scripts de la page pour afficher le form */
$.fn.globalcourtage.loadingJsClients = function() {
    const loader = $('.fixed-loader-wrapper');
    const wrapperDossier = $('.main-wrapper-dossier');

    loader.fadeOut();
    wrapperDossier.removeClass('hide');

    // place le focus sur l'élément de la page.
    setTimeout(() => {
        focusUrl();
    }, 500);
};

/**
 * Permet de placer le focus sur un élément de la page.
 */
const focusUrl = function()
{
    // si un élément à été ciblé dans l'url
    const url = decodeURI(window.location.href);
    const indexCibling = url.indexOf('#'); // la partie cible
    const indexParameters = url.indexOf('?'); // la partie parametres

    // si élément ciblé et que pas de paramètre ou paramètres valides
    if (indexCibling > -1 && (indexParameters == -1 || indexCibling < indexParameters)) {
        let focusElementId = url;

        // retire la partie paramètres
        if (indexParameters > 0) {
            focusElementId = focusElementId.substring(0, indexParameters);
        }

        // retire la partie url
        focusElementId = focusElementId.substring(indexCibling);

        // si la partie du selector avant l'esapce contient 'modal'
        // on est dans le cas d'un élément présent dans une modale, le selector est en plusieurs parties
        let focusModalId = null;
        let $focusModal = null;
        if (focusElementId.substring(0, focusElementId.indexOf(' ')).includes('modal')) {
            // le premier représente la modale à ouvrir.
            focusModalId = focusElementId.substring(0, focusElementId.indexOf(' '));
            $focusModal = $(focusModalId);

            // le second l'input à focus = le reste
            focusElementId = focusElementId.substring(focusElementId.indexOf(' '));
        }

        focusElementId = focusElementId.trim();

        // pour les select, on va focus le span généré par materialize
        if (focusElementId.includes('select[')) {
            focusElementId = focusElementId + '+span';
        }

        if (['#', '#!'].includes(focusElementId)) {
            return;
        }

        let $focusElement = $(focusElementId);

        if ($focusElement.length <= 0) {
            return;
        }

        if ($focusElement.length > 1) {
            $focusElement = $focusElement.first();
        }

        // scroll dessus
        $('html, body').animate({
            scrollTop: parseInt($focusElement.offset().top) - 100
        }, 500);

        // s'il sagit d'une modale. l'ouvre
        if ($focusModal) {
            setTimeout(() => {
                // on scroll sur la position de l'ancre
                const $modalAnquor = $('a[href=\'' + focusModalId + '\']');
                if ($modalAnquor) {
                    $('html, body').animate({
                        scrollTop: parseInt($modalAnquor.offset().top) - (window.innerHeight / 2) // pour centrer
                    }, 500);
                }

                setTimeout(() => {
                    M.Modal.getInstance($focusModal).open();
                }, 750);
            }, 100);
        }

        // exception couts du projet: ouvre le volet.
        if (focusElementId.startsWith('#cout_projet')) {
            setTimeout(() => {
                $('.button-project').trigger('click');
            }, 100);
        }

        // vérifie si un message d'erreur bpce a été indiqué dans les params de l'url
        const queryString = url.substring(url.lastIndexOf('?'));
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.get('bpce_error_msg')) {
            const bpceErrorMsg = urlParams.get('bpce_error_msg');
            setTimeout(function() {
                // souligne l'élément qui pose problème
                $focusElement.attr('style', $focusElement.attr('style') + ';border-bottom: 2px solid red !important');

                // exception pour la modale client et modale pret en cours:
                // on place le message en dessous de la ligne
                // sinon le ciblage casse la présentation
                //TODO: attention a corriger lorsque refonte donnees et clients
                if (focusModalId
                    && (focusModalId.startsWith('#modal-clients') || focusModalId.startsWith('#modal-pret-en-cours')))
                {
                    $focusElement.closest('td').append(
                        '<span class="help-block error-help-block margin-5">Envoi BPCE : ' + bpceErrorMsg + '</span>'
                    );
                    return;
                }

                // erreur sur ligne de pret, on ajout le composant d'erreur en fin du td
                if (focusElementId.startsWith('#prets\\[')) {
                    $focusElement.closest('td').append(
                        '<span class="help-block error-help-block margin-5">Envoi BPCE : ' + bpceErrorMsg + '</span>'
                    );
                    return;
                }

                // autre exception pour les éléments de type date,
                // on rend le message flottant (pas trouvé d'autre solution pour pas casser présentation dans le composant)
                let style = "";
                if ($focusElement.hasClass('mask_date')) {
                    style = "position:absolute;background-color:white;z-index:4;opacity:0.9;top:40px";
                }

                // on place le message
                $focusElement.after('<span class="help-block error-help-block margin-5" style="' + style +
                    '">Envoi BPCE : ' + bpceErrorMsg + '</span>');
            }, 500);
        }
    }
};


/* affiche / masque les lignes lorsque le tableau comporte bcp de résultats */
$.fn.globalcourtage.showHideLines = function() {
    $('.toggle-results').click(function() {
        const lines = $(this).parents('.listing-table').find('tr.line');

        if($(this).find('a').hasClass('active')){
            lines.not('.firsts').addClass('hide');
            $(this).find('a').toggleClass('active').text('Afficher tout');
        }else{
            lines.removeClass('hide');
            $(this).find('a').toggleClass('active').text('Réduire');
        }
    });
};

/* gère le compteur de la requête principale (si existant) */
$.fn.globalcourtage.getCountMainQuery = function() {
    const countQuery = $('#main-query-count');

    if(countQuery.length > 0){
        const countElement = $('#count-elements-query-total');
        countElement.html('<div class="dib-mobile preloader-wrapper extra-small active"><div class="spinner-layer spinner-blue-only"><div class="circle-clipper left"> <div class="circle"></div></div><div class="gap-patch"><div class="circle"></div></div><div class="circle-clipper right"><div class="circle"></div></div></div></div>');

        $.ajax({
            type: 'POST',
            url: '/cqv-a123zefefz13',
            data: {
                "_token": $('[name="csrf-token"]').attr('content'),
                a123zefefz13: countQuery.val()
            },
            dataType: 'html',
            success: function (count) {
                countElement.text(count);
            }
        });
    }
};
/*
* permet de disable les inputs / selects si le profil ne peut pas modifier un dossier soldé
* Si possibilité de modifier le dossier, ajoute la popin au submit
*/
$.fn.globalcourtage.modifDossierSolde = function()
{
    if($('#profil-dossier-solde-input').length > 0)
    {
        const modifDossierSolde = Number($('#profil-dossier-solde-input').val());
        const inputsSelectsPageForm = $('form input:not(.exclude-blocage-input):not([type="hidden"]), form select, form textarea'); // On retire le type hidden de la sélection pour ne pas retirer le champs CSRF du formulaire (#5125)
        // boutons updt ou save + boutons d'enr dans les modales
        const submitFormButton = $('.form-submit-button, .btn-update, .btn-save, .modal-save, .btn-remove, .btn-upload');
        // corbeille suppression de ligne, ajout de ligne (apporteur/commerciaux etc), ajout d'un rdv
        // icone de copie des adrr dans les modales d'édition des clients
        // liste des propositions : nouvelle proposition, suppression des documents
        const btnRemove   = $('.btn-remove-row, .add-button, .btn-add-event, .add-line-button, .delete-line, .copy-adresse, .copy-situation, .nouvelle-proposition');

        if(modifDossierSolde == 1)
        {
            inputsSelectsPageForm.attr('disabled', true);
            submitFormButton.attr('disabled', true);
            btnRemove.hide();
        }
    }
};

/* active les selects dans les points cadeaux à l'ouverture de la modal */
$.fn.globalcourtage.triggerSelectsPointsCadeaux = function() {
    const openButton = $('.trigger-modal-points');

    openButton.click(function() {
        const modal = $(this).next('.modal');
        const interlocuteurId = modal.find('.point-cadeau-interlocuteur-id');

        modal.find('.select-apporteur_agences').trigger('select2:select');
        modal.find('.select-apporteur_interlocuteurs').trigger('select2:select');
        if(interlocuteurId.val()){
            // pas très propre mais pas trouvé d'autres moyens
            setTimeout(function() {
                modal.find('.select-apporteur_interlocuteurs').val(interlocuteurId.val()).trigger('change');
            }, 500);
        }
    });
};

/* gère l'affichage ou non du checkbox parrain principal */
$.fn.globalcourtage.handleParrainPrincipalApporteurs = function() {
    const fieldParrainPrincipal = $('.fieldParrainPrincipal');
    const selectFamilleApporteur = $('.selectFamilleApporteur');

    selectFamilleApporteur.change(function() {
        // 4 = Parrainage
        if($(this).val() == '4'){
            fieldParrainPrincipal.removeClass('hide');
            fieldParrainPrincipal.find('.form-check-input').removeClass('disabled');
            fieldParrainPrincipal.find('input').prop('disabled', false);
        }else{
            fieldParrainPrincipal.addClass('hide');
            fieldParrainPrincipal.find('.form-check-input').addClass('disabled');
            fieldParrainPrincipal.find('input').prop('disabled', true);
        }
    });

    // 4 = Parrainage
    if(selectFamilleApporteur.val() == '4'){
        fieldParrainPrincipal.removeClass('hide');
    }else{
        fieldParrainPrincipal.addClass('hide');
        fieldParrainPrincipal.find('.form-check-input').addClass('disabled');
        fieldParrainPrincipal.find('input').prop('disabled', true);
    }
};

/*
* smooth scroll si hash présent dans l'URL
 */
$.fn.globalcourtage.smoothAnchorScroll = function() {
    if (window.location.hash) {
        const hash = window.location.hash;

        $('html, body').stop().animate({
            scrollTop: $(hash).offset().top
        }, 750, 'swing');
    }
};

/*
* autocomplete filtres select2 commerciaux
 */
$.fn.globalcourtage.autocompleteSelect2Commerciaux = function() {
    const valeurs = ['identite_commercial', 'identite_commercial_principal'];
    let typeListe = 1;// = type liste / 2 = gestion
    const inputListe = $('#type-liste');
    if(inputListe.length>0){
        typeListe = inputListe.val();
    }

    for(const valeur in valeurs){
        let elementSelected = null;

        let idCommercial = null;
        let idCommercialPrincipal = null;
        let idAgence = null;
        let idAgencePrincipale = null;
        let idSociete = null;
        let idSocietePrincipale = null;
        let sortiCheckboxCommercial = null;
        let sortiCheckboxCommercialPrincipal = null;

        $('.autocomplete-select2-'+valeurs[valeur]).select2({
            width: '100%',
            placeholder: '-- Sélectionnez --',
            allowClear: true,
            sorter: function(data) {
                return data.sort(function(a, b) {
                    return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
                });
            },
            ajax: {
                url: '/filters/selects/'+valeurs[valeur],
                dataType: 'json',
                data: function(params){
                    return {
                        q: params.term,
                        commercial: idCommercial,
                        agence: idAgence,
                        societe: idSociete,
                        commercial_principal: idCommercialPrincipal,
                        agence_principale: idAgencePrincipale,
                        societe_principale: idSocietePrincipale,
                        inc_delete_identite_commercial: sortiCheckboxCommercial,
                        inc_delete_identite_commercial_principal: sortiCheckboxCommercialPrincipal,
                        type_liste: typeListe
                    };
                },
                delay: 250,
                processResults: function (data) {
                    const options = [];

                    for(const optionGroup in data){
                        const option = {};
                        option.text = data[optionGroup].label;
                        // option.children = data[optionGroup].list;

                        option.children = $.map(data[optionGroup].list, function (key, item) {
                            return {
                                text: key,
                                id: item
                            };
                        });

                        options.push(option);
                    }

                    const results = {
                        "results": options
                    };

                    return results;
                },
                cache: true
            },
            templateResult: formatTag,
            templateSelection: formatTag
        }).on('select2:opening', function(e){
            elementSelected = e.currentTarget;

            // sortis commercial
            sortiCheckboxCommercial = $('.select-identite_commercial').siblings('.sorti-checkbox').find('input');
            if(sortiCheckboxCommercial.length){
                sortiCheckboxCommercial = (sortiCheckboxCommercial.prop('checked') == true) ? 1 : 0;
            }else{
                sortiCheckboxCommercial = null;
            }

            // cas filtres
            if(idCommercial === undefined){
                idCommercial = $('.select-identite_commercial').val();
                if(idCommercial !== undefined && Array.isArray(idCommercial)){
                    idCommercial = idCommercial.join(',');
                }
            }

            // sortis commercial principal
            sortiCheckboxCommercialPrincipal = $('.select-identite_commercial_principal').siblings('.sorti-checkbox').find('input');
            if(sortiCheckboxCommercialPrincipal.length){
                sortiCheckboxCommercialPrincipal = (sortiCheckboxCommercialPrincipal.prop('checked') == true) ? 1 : 0;
            }else{
                sortiCheckboxCommercialPrincipal = null;
            }

            // cas filtres
            if(idCommercialPrincipal === undefined){
                idCommercialPrincipal = $('.select-identite_commercial_principal').val();
                if(idCommercialPrincipal !== undefined && Array.isArray(idCommercialPrincipal)){
                    idCommercialPrincipal = idCommercialPrincipal.join(',');
                }
            }

            // cas filtres
            idAgence = $('.select-agence').val();
            if(idAgence !== undefined && Array.isArray(idAgence)){
                idAgence = idAgence.join(',');
            }

            idSociete = $('.select-societe').val();
            if(idSociete !== undefined && Array.isArray(idSociete)){
                idSociete = idSociete.join(',');
            }

            idAgencePrincipale = $('.select-agence_principale').val();
            if(idAgencePrincipale !== undefined && Array.isArray(idAgencePrincipale)){
                idAgencePrincipale = idAgencePrincipale.join(',');
            }

            idSocietePrincipale = $('.select-societe_principale').val();
            if(idSocietePrincipale !== undefined && Array.isArray(idSocietePrincipale)){
                idSocietePrincipale = idSocietePrincipale.join(',');
            }
        });
    }

    function formatTag(filteredOption){
        // on applique le style barré sur les options dont la valeur contient le mot "deleted"
        const valeur = filteredOption.id;
        let classAppend;

        if(valeur != undefined && valeur.includes('deleted')) {
            classAppend = "likeDisabledStyle";
        }

        return $('<span class="'+classAppend+'">'+ filteredOption.text+'</span>');
    }
};

/*
* autocomplete filtres select2 apporteurs
 */
$.fn.globalcourtage.autocompleteSelect2Filters = function() {
    const valeurs = ['apporteur', 'apporteur_agence', 'apporteur_interlocuteurs'];

    for(const valeur in valeurs){
        let elementSelected = null;
        let idApporteur = null;
        let idAgenceApporteur = null;
        let idFamilleApporteur = null;
        let idSousFamilleApporteur = null;
        let sortiCheckboxApporteur = null;
        let sortiCheckboxAgenceApporteur = null;
        let sortiCheckboxInterApporteur = null;

        $('.autocomplete-select2-'+valeurs[valeur]).select2({
            width: '100%',
            placeholder: '-- Sélectionnez --',
            allowClear: true,
            sorter: function(data) {
                return data.sort(function(a, b) {
                    return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
                });
            },
            ajax: {
                url: '/filters/selects/'+valeurs[valeur],
                dataType: 'json',
                data: function(params){
                    return {
                        q: params.term,
                        apporteur: idApporteur,
                        ss_famille_apporteur: idSousFamilleApporteur,
                        famille_apporteur: idFamilleApporteur,
                        agence_apporteur: idAgenceApporteur,
                        inc_delete_apporteur: sortiCheckboxApporteur,
                        inc_delete_apporteur_agence: sortiCheckboxAgenceApporteur,
                        inc_delete_apporteur_interlocuteurs: sortiCheckboxInterApporteur,
                    };
                },
                delay: 250,
                processResults: function (data) {
                    return {
                        results: $.map(data, function (key, item) {
                            return {
                                text: key,
                                id: item
                            };
                        })
                    };
                },
                cache: true
            },
            templateResult: formatTag,
            templateSelection: formatTag
        }).on('select2:opening', function(e){
            elementSelected = e.currentTarget;

            // sortis apporteurs
            sortiCheckboxApporteur = $('.select-apporteur').siblings('.sorti-checkbox').find('input');

            if(sortiCheckboxApporteur.length){
                sortiCheckboxApporteur = (sortiCheckboxApporteur.prop('checked') == true) ? 1 : 0;
            }else{
                sortiCheckboxApporteur = null;
            }

            // sortis apporteurs agences
            sortiCheckboxAgenceApporteur = $('.select-apporteur_agence').siblings('.sorti-checkbox').find('input');

            if(sortiCheckboxAgenceApporteur.length){
                sortiCheckboxAgenceApporteur = (sortiCheckboxAgenceApporteur.prop('checked') == true) ? 1 : 0;
            }else{
                sortiCheckboxAgenceApporteur = null;
            }

            // sortis apporteurs inter
            sortiCheckboxInterApporteur = $('.select-apporteur_interlocuteurs').siblings('.sorti-checkbox').find('input');

            if(sortiCheckboxInterApporteur.length){
                sortiCheckboxInterApporteur = (sortiCheckboxInterApporteur.prop('checked') == true) ? 1 : 0;
            }else{
                sortiCheckboxInterApporteur = null;
            }

            // cas dossier
            idApporteur = $(elementSelected).closest('.row-apporteur').find('.select-apporteur-id').val();
            if(idApporteur === undefined){
                idApporteur = $(elementSelected).closest('.row-vendeur').find('.select-vendeur-id').val();
            }

            // cas filtres
            if(idApporteur === undefined){
                idApporteur = $('.select-apporteur').val();
                if(idApporteur !== undefined && Array.isArray(idApporteur)){
                    idApporteur = idApporteur.join(',');
                }
            }

            idAgenceApporteur = $('.select-apporteur_agence').val();
            if (idAgenceApporteur !== undefined && Array.isArray(idAgenceApporteur)) {
                idAgenceApporteur = idAgenceApporteur.join(',');
            }

            // familles / sous familles app
            idSousFamilleApporteur = $('.select-ss_famille_apporteur').val();
            if (idSousFamilleApporteur !== undefined && Array.isArray(idSousFamilleApporteur)) {
                idSousFamilleApporteur = idSousFamilleApporteur.join(',');
            }

            idFamilleApporteur = $('.select-famille_apporteur').val();
            if (idFamilleApporteur !== undefined && Array.isArray(idFamilleApporteur)) {
                idFamilleApporteur = idFamilleApporteur.join(',');
            }

        });
    }

    function formatTag(filteredOption){
        // on applique le style barré sur les options dont la valeur contient le mot "deleted"
        const valeur = filteredOption.id;
        let classAppend;

        if(valeur != undefined && valeur.includes('deleted')) {
            classAppend = "likeDisabledStyle";
        }

        return $('<span class="'+classAppend+'">'+ filteredOption.text+'</span>');
    }
};

/*
* autocomplete filtres select2 banques
 */
$.fn.globalcourtage.autocompleteSelect2FiltersBanques = function() {
    const valeurs = ['banque', 'banque_agence', 'banque_interlocuteurs', 'banque_interlocuteurs2'];
    const options = {'banque' : {'cacher_banques_vides' : true}};
    let elementSelected;

    for(const valeur in valeurs){
        let idBanque = null;
        let idAgenceBanque = null;
        let idAgenceBanque2 = null;
        let idFamilleBanque = null;
        let idSousFamilleBanque = null;
        let sortiCheckboxBanque = null;
        let sortiCheckboxAgenceBanque = null;
        let sortiCheckboxInterBanque = null;

        const urlSearch = valeurs[valeur];
        let urlSearchAjax = valeurs[valeur];

        if(valeurs[valeur] == 'banque_interlocuteurs2'){
            urlSearchAjax = 'banque_interlocuteurs';
        }

        $('.autocomplete-select2-'+urlSearch).select2({
            width: '100%',
            placeholder: '-- Sélectionnez --',
            allowClear: true,
            sorter: function(data) {
                return data.sort(function(a, b) {
                    return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
                });
            },
            ajax: {
                url: '/filters/selects/'+urlSearchAjax,
                dataType: 'json',
                data: function(params){
                    const data = {
                        q: params.term,
                        banque: idBanque,
                        ss_famille_banque: idSousFamilleBanque,
                        famille_banque: idFamilleBanque,
                        agence_banque: idAgenceBanque,
                        inc_delete_banque: sortiCheckboxBanque,
                        inc_delete_banque_agence: sortiCheckboxAgenceBanque,
                        inc_delete_banque_interlocuteurs: sortiCheckboxInterBanque
                    };

                    if (options[valeurs[valeur]] != null) {
                        data.options = options[valeurs[valeur]];
                    }

                    return data;
                },
                delay: 250,
                processResults: function (data) {
                    return {
                        results: $.map(data, function (key, item) {
                            return {
                                text: key,
                                id: item
                            };
                        })
                    };
                },
                cache: true
            },
            templateResult: formatTag,
            templateSelection: formatTag
        }).on('select2:opening', function(e){
            elementSelected = e.currentTarget;

            // sortis banques
            sortiCheckboxBanque = $('.select-banque').siblings('.sorti-checkbox').find('input');

            if(sortiCheckboxBanque.length){
                sortiCheckboxBanque = (sortiCheckboxBanque.prop('checked') == true) ? 1 : 0;
            }else{
                sortiCheckboxBanque = null;
            }

            // sortis banques agences
            sortiCheckboxAgenceBanque = $('.select-banque_agence').siblings('.sorti-checkbox').find('input');

            if(sortiCheckboxAgenceBanque.length){
                sortiCheckboxAgenceBanque = (sortiCheckboxAgenceBanque.prop('checked') == true) ? 1 : 0;
            }else{
                sortiCheckboxAgenceBanque = null;
            }

            // sortis banques inter
            sortiCheckboxInterBanque = $('.select-banque_interlocuteurs').siblings('.sorti-checkbox').find('input');

            if(sortiCheckboxInterBanque.length){
                sortiCheckboxInterBanque = (sortiCheckboxInterBanque.prop('checked') == true) ? 1 : 0;
            }else{
                sortiCheckboxInterBanque = null;
            }

            // cas filtres
            idBanque = $('.select-banque').val();

            if(idBanque !== undefined && Array.isArray(idBanque)){
                idBanque = idBanque.join(',');
            }

            idAgenceBanque = $('.select-banque_agence').val();

            if(idAgenceBanque !== undefined && Array.isArray(idAgenceBanque)){
                idAgenceBanque = idAgenceBanque.join(',');
            }

            idAgenceBanque2 = $('.select-banque_agence.seconde-agence-banque').val();

            if(idAgenceBanque2 !== undefined && Array.isArray(idAgenceBanque2)){
                idAgenceBanque2 = idAgenceBanque2.join(',');
            }

            if(valeurs[valeur] == 'banque_interlocuteurs2'){
                idAgenceBanque = idAgenceBanque2;
            }

            // familles / sous familles app
            idSousFamilleBanque = $('.select-ss_famille_banque').val();
            idFamilleBanque = $('.select-famille_banque').val();

            if(idSousFamilleBanque !== undefined && Array.isArray(idSousFamilleBanque)){
                idSousFamilleBanque = idSousFamilleBanque.join(',');
            }

            if(idFamilleBanque !== undefined && Array.isArray(idFamilleBanque)){
                idFamilleBanque = idFamilleBanque.join(',');
            }
        }).on('select2:select', function() {
            autocompleteFiltersBanques($(this), urlSearchAjax);
        });
    }

    function formatTag(filteredOption){
        // on applique le style barré sur les options dont la valeur contient le mot "deleted"
        const valeur = filteredOption.id;
        let classAppend;

        if(valeur != undefined && valeur.includes('deleted')) {
            classAppend = "likeDisabledStyle";
        }

        return $('<span class="'+classAppend+'">'+ filteredOption.text+'</span>');
    }

    /*  Filtres select2 sur Banque ou Agence
    **  Autocomplete de Banque et/ou Agence lors de la sélection d'une Agence et/ou d'un Interlocuteur (completion du parent depuis l'enfant)
    */
    function autocompleteFiltersBanques(selectField, urlSearch)
    {
        // n'actualise le(s) parent(s) que si changement d'agence ou d'interlocuteur.
        if (!['banque_agence', 'banque_interlocuteurs'].includes(urlSearch)) {
            return;
        }

        $.ajax({
            type: 'get',
            url: '/filters/selects/infosParentBanque',
            data: {
                entityType: urlSearch,
                id: selectField.val(),
            },
            dataType: 'json',
            success: function (data) {
                // remet à jour le select d'agence après une selection d'interlocuteur
                if (urlSearch == 'banque_interlocuteurs') {
                    let champAgenceLie = $('.autocomplete-select2-banque_agence');
                    const selecteurAgenceLiee = selectField.data("selecteur_agence_liee");
                    if(selecteurAgenceLiee){
                        champAgenceLie = $(selecteurAgenceLiee);
                    }

                    // remplace les agences d'autocomplete par la seule agence utile et la selectionne
                    const newOptionAgence = new Option(data['agence']['label'], data['agence']['id'], false, false);
                    champAgenceLie
                        .html(newOptionAgence)
                        .val(data['agence']['id'])
                        .trigger('change')
                    ;
                }

                // remet à jour le select banque après une selection d'interlocuteur ou d'agence
                // remplace les banques d'autocomplete par la seule banque utile et la selectionne
                var newOptionBanque = new Option(data['banque']['label'], data['banque']['id'], false, false);
                $('.autocomplete-select2-banque')
                    .html(newOptionBanque)
                    .val(data['banque']['id'])
                    .trigger('change')
                ;
            }
        });
    }
};

/* gère l'optgroup d'aide à la saisie */
$.fn.globalcourtage.getAideSaisieOptgroup = function() {
    let optgroup = '';

    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0');
    let yyyy = today.getFullYear();
    today = dd + '/' + mm + '/' + yyyy;

    let yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    dd = String(yesterday.getDate()).padStart(2, '0');
    mm = String(yesterday.getMonth() + 1).padStart(2, '0');
    yyyy = yesterday.getFullYear();
    yesterday = dd + '/' + mm + '/' + yyyy;

    let moisCours = new Date();
    moisCours.setDate(moisCours.getDate());
    dd = String('01');
    mm = String(moisCours.getMonth() + 1).padStart(2, '0');
    yyyy = moisCours.getFullYear();
    moisCours = dd + '/' + mm + '/' + yyyy;

    let anneeCours = new Date();
    anneeCours.setDate(anneeCours.getDate());
    dd = String('01');
    mm = String('01');
    yyyy = anneeCours.getFullYear();
    const currentYear = yyyy;
    anneeCours = dd + '/' + mm + '/' + yyyy;

    let date7jours = new Date();
    date7jours.setDate(date7jours.getDate() - 7);
    dd = String(date7jours.getDate()).padStart(2, '0');
    mm = String(date7jours.getMonth() + 1).padStart(2, '0');
    yyyy = date7jours.getFullYear();
    date7jours = dd + '/' + mm + '/' + yyyy;

    let date30jours = new Date();
    date30jours.setDate(date30jours.getDate() - 30);
    dd = String(date30jours.getDate()).padStart(2, '0');
    mm = String(date30jours.getMonth() + 1).padStart(2, '0');
    yyyy = date30jours.getFullYear();
    date30jours = dd + '/' + mm + '/' + yyyy;

    optgroup = `<option value='between' data-debut='${today}' data-fin='${today}'>Aujourd'hui</option> \
        <option value='between' data-debut='${yesterday}' data-fin='${yesterday}'>Hier</option> \
        <option value='between' data-debut='${moisCours}' data-fin='${today}'>Mois en cours</option> \
        <option value='between' data-debut='${anneeCours}' data-fin='${today}'>Année en cours</option> \
        <option value='between' data-debut='${date7jours}' data-fin='${today}'>7 derniers jours</option> \
        <option value='between' data-debut='${date30jours}' data-fin='${today}'>30 derniers jours </option>`;

    const monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
        "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    ];

    const month = new Date().getMonth();
    const year = new Date().getFullYear();


    /* 6 derniers mois */
    for(let count = 0; count < 6; count++){
        const mois = globalcourtage.addMonths(new Date(),-count);
        const moisNumber = mois.getMonth();
        const mm = String(mois.getMonth() + 1).padStart(2, '0');
        const yyyy = mois.getFullYear();

        let lastDayMonth = new Date(yyyy, moisNumber + 1, 0);
        lastDayMonth = lastDayMonth.getDate();

        optgroup += `<option value='between' data-debut="01/${mm}/${yyyy}" data-fin='${lastDayMonth}/${mm}/${yyyy}'>${monthNames[moisNumber]} - ${yyyy}</option>`;
    }

    /* trimestres */
    const trimestreDepart = Math.floor(month/3,10)+1;
    const monthTrimestreDepart = (trimestreDepart-1)*3;

    const nbTrimestres = 8;
    for(let index_boucle=0; index_boucle<nbTrimestres; index_boucle++){
        const debut = new Date(year,monthTrimestreDepart-(3*index_boucle),1);
        const fin = new Date(year,monthTrimestreDepart-(3*index_boucle)+3,0);

        const jour_debut = String(debut.getDate()).padStart(2, '0');
        const mois_debut = String(debut.getMonth() + 1).padStart(2, '0');
        const annee_debut = debut.getFullYear();

        const jour_fin = String(fin.getDate()).padStart(2, '0');
        const mois_fin = String(fin.getMonth() + 1).padStart(2, '0');
        const annee_fin = fin.getFullYear();

        const trimestre = Math.floor(debut.getMonth()/3,10)+1;

        optgroup += `<option value='between' \
            data-debut="${jour_debut}/${mois_debut}/${annee_debut}" \
            data-fin='${jour_fin}/${mois_fin}/${annee_fin}'>Trimestre ${trimestre} - ${annee_debut}</option>`;
    }

    /* semestres */
    const semestreDepart = Math.floor(month/6)+1;
    const monthSemestreDepart = (trimestreDepart-1)*6;

    const nbSemestres = 4;
    for(let index_boucle=0; index_boucle<nbSemestres; index_boucle++){
        const debut = new Date(year,monthSemestreDepart-(6*index_boucle),1);
        const fin = new Date(year,monthSemestreDepart-(6*index_boucle)+6,0);

        const jour_debut = String(debut.getDate()).padStart(2, '0');
        const mois_debut = String(debut.getMonth() + 1).padStart(2, '0');
        const annee_debut = debut.getFullYear();

        const jour_fin = String(fin.getDate()).padStart(2, '0');
        const mois_fin = String(fin.getMonth() + 1).padStart(2, '0');
        const annee_fin = fin.getFullYear();

        const semestre = Math.floor(debut.getMonth()/6,10)+1;

        optgroup += `<option value='between' \
            data-debut="${jour_debut}/${mois_debut}/${annee_debut}" \
            data-fin='${jour_fin}/${mois_fin}/${annee_fin}'>Semestre ${semestre} - ${annee_debut}</option>`;
    }

    /* 3 dernières années */
    for(let annee = currentYear; annee >= (currentYear - 2); annee--){
        optgroup += `<option value='between' data-debut='01/01/${annee}' data-fin='31/12/${annee}'>${annee}</option>`;
    }

    return optgroup;
};

/* calcul l'écart entre deux dates et renvoie le résultat en mois */
$.fn.globalcourtage.calculateRangeBetweenDates = function() {
    $('body').on('blur', ".range-date-first, .range-date-second", function () {
        let dateDebut;
        let dateFin;
        const wrapper = $(this).closest('.range-calcul-wrapper');

        if ($(this).hasClass('range-date-first')) {
            dateDebut = $(this).val();
            dateFin = wrapper.find('.range-date-second').val();
        } else {
            dateDebut = wrapper.find('.range-date-first').val();
            dateFin = $(this).val();
        }

        // conversion fr to sql (si renseigné)
        if (dateDebut != '') {
            dateDebut = dateDebut.split('/');
            dateDebut = dateDebut[2] + '-' + dateDebut[1] + '-' + dateDebut[0];
        }
        if (dateFin != '') {
            dateFin = dateFin.split('/');
            dateFin = dateFin[2] + '-' + dateFin[1] + '-' + dateFin[0];
        }

        // exception pour les prets en cours
        const name = $(this).attr('name');
        if (name && name.startsWith('pret_en_cours')) {
            if (dateFin != '') {
                // si date début non renseigné ou que date < aujourd'hui (pret entamé),
                // calcule la durée depuis la date actuelle
                if (dateDebut == '' || (new Date(dateDebut) < new Date())) {
                    dateDebut = new Date().toDateString();
                }

                // si la date de début est après date fin, ramène à date de fin (durée restante nulle donc)
                // ex. lorsque dateDebut n'est pas renseigné mais que date du jour > date fin du pret
                if(new Date(dateDebut) > new Date(dateFin)) {
                    dateDebut = dateFin;
                }
            } else {
                // si pas de date de fin renseignée, désactive le calcul en supprimant la date début
                dateDebut = '';
            }
        }

        if (dateDebut != '' && dateFin != '') {
            const range = Math.floor(((new Date(dateFin)) - new Date(dateDebut)) / (86400000 * (365 / 12)));
            const rangeYears = Math.floor(((new Date(dateFin)) - new Date(dateDebut)) / (86400000 * 365));

            if (!isNaN(range)) {
                wrapper.find(".months-between-dates").html(range + " mois");
                wrapper.find(".years-between-dates").html(rangeYears + " ans");
            }
        } else {
            wrapper.find(".months-between-dates").html('');
            wrapper.find(".years-between-dates").html('');
        }
    });

    $('.range-date-first, .range-date-second').blur();
};

$.fn.globalcourtage.handleAlertBox = function() {
    $('body').delegate('.alert-box .close-link', 'click', function() {
        $(this).closest('.alert-box').fadeOut();

        // cas messages bandeau par ex
        if($(this).data('message') !== undefined){
            const messageID = $(this).data('message');
            $.ajax({
                type: 'post',
                url: '/messages-bandeau/' + messageID + '/seen',
                data: {
                    _token: $('[name="csrf-token"]').attr('content')
                }
            });
        }
    });
};

/* Ajoute un nombre de mois (months) à une date donnée */
$.fn.globalcourtage.addMonths = function(date, months) {
    const newDate = new Date(date.getTime()); // copie de la variable d'origine
    var dayOfMonth = newDate.getDate();

    newDate.setMonth(newDate.getMonth() + months);

    // vérifie si le jour après ajout correspond au jour de la date d'origine
    // sinon mois suivant (ex. cas 31 mars - 1 mois)
    if (newDate.getDate() != dayOfMonth) {
        newDate.setDate(0); // 0 du mois = dernier jour du mois précédent
    }
    return newDate;
};

const initScrollable = true;
const $scrollableTable = $('.scrollable-table');
let $scrollableTableHeader;
let $header;
const dropdownColumns = false;

$.fn.globalcourtage.initScrollableTable = function () {
    /*if($scrollableTable.length == 0) {
        return;
    }

    if (initScrollable) {
        //On masque le thead
        $scrollableTable.find('table').css({
            'margin-top': $scrollableTable.find('table thead tr')[0].offsetHeight * -1
        });
    }

    //On récupère la taille des colonnes
    const tdWidth = [];
    $scrollableTable.find('table tbody tr:first-child td').each(function () {
        tdWidth.push($(this)[0].offsetWidth);
    });

    //On construit notre header
    if (initScrollable) {
        $scrollableTableHeader = $('<div class="scrollable-table-header"></div>');
        $header = $('<div class="header"></div>');
        $scrollableTableHeader.append($header);

        if ($scrollableTable.find('#dropdown-columns').length > 0) {
            dropdownColumns = true;
        }
    } else {
        if (dropdownColumns) {
            $header.children(':not(:first)').remove();
        } else {
            $header.children().remove();
        }
    }

    $header.css({
        width: $scrollableTable[0].offsetWidth,
    });

    let idx = 0;
    $scrollableTable.find('table thead tr th').each(function () {
        if (idx === 0 && dropdownColumns) {
            if (initScrollable) {
                const $col = $('<div></div>').html($(this).html()).addClass($(this).attr('class'));
                $(this).html("");

                tdWidth[0] = $scrollableTable.find('table tbody tr:first-child td:first-child')[0].offsetWidth;

                $col.css({
                    width: tdWidth[idx],
                    flex: '0 0 ' + tdWidth[idx] + 'px'
                });

                $header.append($col);
            }
        } else {
            const $col = $('<div></div>').html($(this).html()).addClass($(this).attr('class'));
            $col.css({
                width: tdWidth[idx],
                flex: '0 0 ' + tdWidth[idx] + 'px'
            });

            $header.append($col);
        }

        idx++;
    });

    if (initScrollable) {
        initScrollable = false;

        $scrollableTableHeader.insertBefore($scrollableTable);

        $.fn.globalcourtage.handleListingColumns();

        $scrollableTable.on("scroll", function (e) {
            $header[0].scrollLeft = e.currentTarget.scrollLeft;
        });

        $header.on("scroll", function (e) {
            $scrollableTable[0].scrollLeft = e.currentTarget.scrollLeft;
        });
    }*/
};

$.fn.globalcourtage.modalDraggable = function(element = null) {
    const $modal = $('#' + element.id);

    $modal.draggable({
        handle: ".modal-title",
    });
};

/* gère le select du commercial par défaut pour le fmb */
$.fn.globalcourtage.handleDefautCommercialFMB = function() {
    const commercialDefautFMB = $('.wrapper-select-fmb');
    const checkboxAccesFMB = $('.acces-fmb-checkbox');

    if(checkboxAccesFMB.prop('checked') == true){
        commercialDefautFMB.removeClass('hide');
    }else{
        commercialDefautFMB.addClass('hide');
    }

    checkboxAccesFMB.click(function(){
        if($(this).prop('checked') == true){
            commercialDefautFMB.removeClass('hide');
        }else{
            commercialDefautFMB.addClass('hide');
        }
    });
};

/* gère la popin de politique de conf des données pour les clients  */
$.fn.globalcourtage.handlePolitiqueConfDonnees = function() {
    const societePolConfDonnees = $('#societe-politique-donnees');

    if(societePolConfDonnees.length > 0){
        if(societePolConfDonnees.val() == 1){
            const modalPolConfDonnees = $('.modal-politique-conf-donnees');

            modalPolConfDonnees.modal({
                dismissible: false
            });
            modalPolConfDonnees.modal('open');
        }
    }
};

/* Ajoute une class pour overflow auto les tableaux de tâches sur petits écrans */
$.fn.globalcourtage.addOATachesWrapper = function() {
    const tachesContainer = $('.home-container .taches-container');

    if($(window).width() < 1268) {
        tachesContainer.addClass('overflow-auto-row');
    }else{
        tachesContainer.removeClass('overflow-auto-row');
    }

    $(window).resize(function(){
        if($(window).width() < 1268) {
            tachesContainer.addClass('overflow-auto-row');
        }else{
            tachesContainer.removeClass('overflow-auto-row');
        }
    });
};

/* alerte l'utilisateur lorsqu'il tente de changer de page après avoir effectué une modif d'input */
$.fn.globalcourtage.alertBeforeLeavingPage = function () {
    if($('.form-alert-before-submit').length > 0) {
        /**
         * Affcihe le message natif du navigateur pour vérifier que les données
         * sont bien enregistrer.
         * developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
         */
        const beforeUnloadHandler = (event) => {
            event.preventDefault();

            // Included for legacy support Chrome/Edge < 119 (2023-10-31)
            event.returnValue = true;
        };

        function handleAlertsBeforeLeaving() {
            $(".form-alert-before-submit input, .form-alert-before-submit textarea").on('input', function () {
                if (!$(this).hasClass('alert-excluding')) {
                    window.addEventListener("beforeunload", beforeUnloadHandler);
                }
            });

            $(".form-alert-before-submit select").on('change', function () {
                if (!$(this).hasClass('alert-excluding')) {
                    window.addEventListener("beforeunload", beforeUnloadHandler);
                }
            });

            // si on supprime une ligne (par ex dans données clients & projet), on déclenche l'event lorsqu'on essaie de quitter la page
            $('.form-alert-before-submit .delete-line').on('click', function () {
                if ($(this).attr('class').indexOf('exclude-blocage-input') == -1) {
                    window.addEventListener("beforeunload", beforeUnloadHandler);
                }
            });

            // retire l'alerte navigateur si on submit le formulaire
            $(".form-alert-before-submit").on('submit', function () {
                window.removeEventListener("beforeunload", beforeUnloadHandler);
            });
        }

        setTimeout(handleAlertsBeforeLeaving, 1000);
    }
};

/* empêche la double validation des formulaires d'édition / création  */
$.fn.globalcourtage.preventDoubleValidation = function() {
    // selection des boutons submit en dehors de ceux d'une page d'inertia (submit interne).
    const submitButton = $('button[type="submit"]')
        .not('#inertia-app button[type="submit"]');

    const loader = '<div class="preloader-wrapper extra-small active"><div class="spinner-layer spinner-white-only"><div class="circle-clipper left"> <div class="circle"></div></div><div class="gap-patch"><div class="circle"></div></div><div class="circle-clipper right"><div class="circle"></div></div></div></div>';

    if (submitButton.length > 0) {
        //TODO : Voir avec Vincent pk rajouter le timeout car ça pète tout !!!
        submitButton.click(function () {
            const $form = $(this).closest('form');
            if ($form.valid()) {
                $(this).prop('disabled', true);
                $(this).addClass('disabled');
                $(this).find('i').html(loader);
                $form.submit();
            }
        });
    }
};
